// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:26:09.764Z
// Property: The Drake at Deerwood (ID: 6737460151191297)
// Collections: 28 amenities, 9 floorplans (live), 26 photos, 82 POIs, 5 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "6737460151191297",
  "property_external_id": "5203549",
  "property_zillow_url": "https://www.zillow.com/homedetails/9727-Touchton-Rd-Jacksonville-FL-32246/2065149250_zpid/",
  "property_apartments_url": "https://www.apartments.com/the-drake-at-deerwood-jacksonville-fl/5gj5dpp",
  "property_google_business_url": "https://www.google.com/maps/place/The+Drake+at+Deerwood/data=!4m2!3m1!1s0x0:0x13833ee7daa7bf8b?sa=X&ved=2ahUKEwj2n-Gi2bySAxXVmSYFHYgXN3EQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "16626299920",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-drake-at-deerwood",
  "property_name": "The Drake at Deerwood",
  "property_website_url": "https://www.lifeatthedrake.com/",
  "property_domain": "https://www.lifeatthedrake.com/",
  "property_address": "9727 Touchton Rd",
  "property_full_address": "9727 Touchton Rd, Jacksonville, FL 32246",
  "property_address_1": "9727 Touchton Rd",
  "property_address_2": null,
  "property_address_city": "Jacksonville",
  "property_address_state": "FL",
  "property_address_zip_full": "32246-8229",
  "property_address_zip": "32246",
  "property_address_country": "US",
  "property_address_county": "Duval County",
  "property_neighborhood_address": "Windy Hill",
  "property_address_latitude": "30.26983",
  "property_address_longitude": "-81.5543323",
  "property_email": "drake@alapts.com",
  "property_phone": "(904) 374-2000",
  "property_call_tracking_phone": "904-977-5758",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Southside convenience with a polished Deerwood feel.</strong> Discover one-, two-, and three-bedroom apartments with chef-style kitchens, granite countertops, wood-style flooring, screened porches, and spaces designed for easy downtime—then schedule a tour to see The Drake at Deerwood in person.</p>",
  "property_long_description": "<p><strong>Southside convenience with a polished Deerwood feel.</strong> At The Drake at Deerwood, you’re tucked into one of Jacksonville’s most connected corridors, close to St. Johns Town Center’s open-air shopping and dining, Tinseltown entertainment, UNF, and everyday routes like Southside Boulevard, JTB, and I-295.</p><p>Choose from <a href=\"/floor-plans\">one-, two-, and three-bedroom apartments</a> with the finishes that make daily life feel easy: chef-style kitchens with stainless steel appliances, granite countertops, decorative tile backsplashes, wood-style plank flooring, in-home washer and dryer, generous closets, screened porches, and available lake, pool, or wooded views.</p><p>Beyond your door, the community is built for real downtime and productive routines—think a sundrenched <a href=\"/amenities\">pool and sundeck</a>, outdoor kitchen with grills and seating, resident lounge with an oversized brick fireplace, billiards game room, modern fitness and cardio spaces, sand volleyball, dog parks, EV charging, and controlled-access entry. Explore the area on the <a href=\"/neighborhood\">neighborhood page</a>, then see why The Drake fits Jacksonville living so well.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019d02f5-a8fe-76de-86ef-34c6145de92f.webp",
  "property_featured_image_media": {
    "alt_text": "Living room and dining area with a blue floral accent wall and modern furniture.",
    "public_id": "019d02f5-a8fe-76de-86ef-34c6145de92f",
    "storage_key": "property/6737460151191297/019d02f5-a8fe-76de-86ef-34c6145de92f.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "322",
  "property_year_built": "2001",
  "property_year_renovated": "2023",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.27329192546584",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Application Fee $85\nAdministrative Fee $250\nNon-Refundable Pet Fee $350 / pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $399\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://9028628.onlineleasing.realpage.com/#k=63963",
  "property_resident_portal_url": "https://thedrakeatdeerwood.loftliving.com/login",
  "property_apply_now_url": "https://9028628.onlineleasing.realpage.com/#k=63963",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e706f-e70c-70e1-8ee4-c04c245849b5.webp",
  "property_primary_logo_media": {
    "alt_text": "The Drake at Deerwood logo",
    "public_id": "019e706f-e70c-70e1-8ee4-c04c245849b5",
    "storage_key": "property/6737460151191297/019e706f-e70c-70e1-8ee4-c04c245849b5.webp",
    "width": 2331,
    "height": 499
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e706f-e77a-75c2-a3b6-1bf8a223258a.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Drake at Deerwood Premier Apartments logo",
    "public_id": "019e706f-e77a-75c2-a3b6-1bf8a223258a",
    "storage_key": "property/6737460151191297/019e706f-e77a-75c2-a3b6-1bf8a223258a.webp",
    "width": 2331,
    "height": 744
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e706f-e9b7-701c-be98-ab6c0873aa16.webp",
  "property_icon_media": {
    "alt_text": "Drake logo",
    "public_id": "019e706f-e9b7-701c-be98-ab6c0873aa16",
    "storage_key": "property/6737460151191297/019e706f-e9b7-701c-be98-ab6c0873aa16.webp",
    "width": 2400,
    "height": 2400
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e706f-e9b7-701c-be98-ab6c0873aa16.webp",
  "property_fav_icon_media": {
    "alt_text": "Drake logo",
    "public_id": "019e706f-e9b7-701c-be98-ab6c0873aa16",
    "storage_key": "property/6737460151191297/019e706f-e9b7-701c-be98-ab6c0873aa16.webp",
    "width": 2400,
    "height": 2400
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e706f-e7f5-727b-8388-53d59d94297b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Drake at Deerwood Premier Apartments logo.",
    "public_id": "019e706f-e7f5-727b-8388-53d59d94297b",
    "storage_key": "property/6737460151191297/019e706f-e7f5-727b-8388-53d59d94297b.webp",
    "width": 2331,
    "height": 744
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f8afe-3b10-75dc-a398-9911dddb761c.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f8afe-3b10-75dc-a398-9911dddb761c",
    "storage_key": "property/6737460151191297/019f8afe-3b10-75dc-a398-9911dddb761c.webp",
    "width": 1280,
    "height": 274
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#0a4975",
  "property_secondary_color": "#5e6e7d",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#020202",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "559 - 1390",
  "property_sqft_min": "559",
  "property_sqft_max": "1390",
  "property_price_range": "1203.16 - 2140",
  "property_price_min": "1203.16",
  "property_price_max": "2140",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/thedrakeatdeerwood",
  "property_instagram_url": "https://www.instagram.com/thedrakeatdeerwood/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJVbg1uHC15YgRi7-n2uc-gxM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_near=eddison-at-deerwood-park-jacksonville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities with momentum.</strong> From modern fitness and cardio spaces to a sundrenched pool and outdoor kitchen with grills, seating, and cabana-style spaces, The Drake at Deerwood makes downtime feel effortless. Apartment interiors add chef-style kitchens, granite countertops, stainless steel appliances, wood-style plank flooring, in-home laundry, USB outlets, and screened porches with select lake, pool, or wooded views—plus extras like a billiards lounge, EV charging, dog parks, and available garage or boat parking.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at The Drake at Deerwood.</strong> Choose from one-, two-, and three-bedroom apartments with polished finishes like chef-style kitchens, stainless steel appliances, granite countertops, tile backsplashes, wood-style plank flooring, in-home laundry, and generous closet space. Select homes add screened porches and lake, pool, or wooded views for an inviting everyday backdrop.</p>",
  "property_home_gallery_blurb": "<p><strong>Take a closer look.</strong> Preview light-filled interiors with wood-style flooring, chef-style kitchens with granite counters and stainless steel appliances, and screened porches with lake, pool, or wooded views in select homes. Then browse scenes from the sundrenched pool, cabana seating, outdoor kitchen, resident lounge with brick fireplace and billiards, fitness spaces, dog parks, and landscaped Deerwood surroundings.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Deerwood puts Jacksonville within easy reach.</strong> Grab a bite near Deer Lake, shop open-air at St. Johns Town Center, play a round at Topgolf, or unwind at Touchton Road Park. For a greener escape, UNF’s Robert W. Loftin Nature Trails bring shaded paths and boardwalk views close to the retail buzz—all with JTB, I-295, Southside Boulevard, and JTA service nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>See what stands out at The Drake at Deerwood.</strong> Reviews point to a friendly leasing team, responsive maintenance, and a quiet, well-kept setting in a convenient Deerwood location. Residents also call out quick service requests, welcoming staff, resident events, outdoor gathering spaces, and pet-friendly areas that make everyday downtime easier. Read more to hear the feedback firsthand.</p>",
  "property_neighborhood_blurb": "<p><strong>Let Deerwood be your launch point.</strong> From The Drake at Deerwood, your day can move from a quick bite around Deer Lake to open-air shopping at St. Johns Town Center, a round at Topgolf, or a low-key reset at Touchton Road Park. When you want more green space, UNF’s Robert W. Loftin Nature Trails add miles of shaded paths and boardwalk moments just beyond the retail buzz. JTB, I-295, Southside Boulevard, and nearby JTA service keep the rest of Jacksonville within easy reach, whether you’re heading toward the Beaches, downtown, or the Southside business corridor. Explore the map below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood fits around life at The Drake.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep the day moving.</strong> At The Drake at Deerwood, you can shift from focused time to downtime without leaving the community—get a workout in at the modern fitness and cardio spaces, cool off at the sundrenched pool, or meet the evening at the outdoor kitchen with barbecue grills, seating, and cabana-style spaces.</p><p>Inside, details feel just as considered: chef-style kitchens with stainless steel appliances, granite countertops, custom cabinetry with wine rack, wood-style plank flooring, in-home washer and dryer, USB outlets, generous storage, and screened porches with select lake, pool, or wooded views. A billiards lounge, resident clubhouse with an oversized brick fireplace, updated dog parks, EV charging, and available garage or trailer/boat parking add extra ease. Browse the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Drake at Deerwood home?</strong><br>Start your application online for a one-, two-, or three-bedroom apartment with polished finishes like stainless steel appliances, granite countertops, wood-style plank flooring, in-home laundry, generous closets, and screened porches—all in a connected Southside setting built for easy everyday living.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact The Drake at Deerwood leasing team for details on apartment availability, polished in-home finishes, community features, or directions to our connected Southside location. We’ll help you take the next step with confidence.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Drake at Deerwood?</strong> Start here for quick answers on leasing, apartment features, amenities, and everyday living in our polished Southside community. If you don’t see what you need, our leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the space that fits your routine.</strong> The Drake at Deerwood offers one-, two-, and three-bedroom apartments, from efficient one-bedroom homes to larger two-bath layouts with room to spread out. As you compare availability, look for the details that make each floor plan feel finished: chef-style kitchens with stainless steel appliances, sleek granite countertops, decorative tile backsplashes, wood-style plank flooring, in-home washer and dryer, generous closets, and screened porches in select homes. Some layouts also add lake, pool, or wooded views for a calmer backdrop to your day. Browse the options below, explore the <a href=\"/amenities\">apartment features</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your preferred layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the details before you visit.</strong> The Photo Gallery at The Drake at Deerwood brings the community into focus: light-filled living areas with wood-style flooring, chef-style kitchens framed by granite counters and stainless steel, and screened porches that open to lake, pool, or wooded views in select homes.</p><p>Scroll from the sundrenched pool and cabana seating to the outdoor kitchen, then step inside the resident lounge where an oversized brick fireplace and billiards space add character. You’ll also catch the updated fitness spaces, dog parks, and quiet landscaped moments that shape the Deerwood setting. Like what you see? Compare <a href=\"/floor-plans\">available layouts</a>, explore more <a href=\"/amenities\">features and finishes</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Drake at Deerwood on the map.</strong><br>See available apartments in a connected Southside setting near shopping, dining, entertainment, and key Jacksonville routes—then zoom out to get a feel for the polished Deerwood location around you.</p>",
  "property_pets_blurb": "<p><strong>Bring the tail wags and sunbeam naps.</strong> At The Drake at Deerwood, cats and dogs are part of the everyday rhythm, with pet-friendly apartment homes, no weight limit, and updated modern dog parks that make quick outings easier close to home. Inside, in-home washers and dryers, large closets, and screened porches in select homes help keep daily routines comfortable after muddy paws or sunny strolls.</p><p>When you’re ready to wander, the Deerwood setting puts pet errands and local veterinary care within an easy drive, while the community’s gated entry and outdoor gathering spaces give you more reasons to step outside. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how life with your cat or dog can feel here.</p>",
  "property_referafriend_blurb": "<p><strong>Share the polished Deerwood lifestyle.</strong> If you love the easy Southside convenience, stylish <a href=\"/floor-plans\">one-, two-, and three-bedroom apartments</a>, and downtime-ready <a href=\"/amenities\">community amenities</a> at The Drake at Deerwood, invite a friend to experience it too. Send a referral and help them find their next Jacksonville apartment here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Drake at Deerwood.</strong><br>Pay rent, submit maintenance requests, and manage your account with the same easy Southside convenience that defines life here—polished apartment finishes, productive routines, and downtime-ready community spaces all in one connected Jacksonville setting.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback from life at The Drake at Deerwood.</strong> Residents often highlight the friendly leasing team, responsive maintenance, and a community that feels well cared for day to day. One reviewer called it “by far the best experience” they’d had after living in several apartment communities, noting quick service requests and a quiet, well-maintained setting.</p><p>You’ll also see praise for the convenient Deerwood location, welcoming staff, resident events, and amenities that make downtime easy—from outdoor gathering spaces to pet-friendly areas. Browse the reviews below to hear directly from residents about what stands out most.</p>",
  "property_created_at": "1752257041342",
  "property_scheduletour_blurb": "<p><strong>See The Drake at Deerwood in person.</strong> Tour polished one-, two-, and three-bedroom apartments with chef-style kitchens, granite countertops, wood-style plank flooring, screened porches, and generous closets—then explore inviting community spaces designed for downtime and daily ease. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon. In the meantime, picture polished Deerwood living with spacious one-, two-, and three-bedroom apartments, chef-style kitchens, screened porches, and inviting spaces for downtime, from the pool and sundeck to the resident lounge.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> The Drake at Deerwood’s virtual tours let you move through the spaces at your own pace, from community walk-throughs to a one-bedroom apartment tour that shows the open living area, kitchen sightlines, granite-style surfaces, stainless steel appliances, and in-home laundry details up close.</p><p>Explore the Clubroom to get a feel for the lounge atmosphere, then preview the Fitness Center with its bright workout zones and equipment layout. These tours are a simple way to compare the look, flow, and finish of everyday spaces before you browse <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> in Jacksonville.</p>",
  "property_copyright": "2025 All Rights Reserved. The Drake at Deerwood",
  "property_seo_title_home": "The Drake at Deerwood | Apartments in Jacksonville, FL",
  "property_seo_description_home": "Discover your dream home at The Drake at Deerwood in Jacksonville, FL! Our community offers a variety of spacious floor plans, including one, two, and three-bedroom apartments, perfect for any lifestyle. Enjoy luxurious amenities like a fitness center, clubhouse, dog park, and stunning lake views. With modern finishes, smart locks, and convenient online resident services, you'll experience comfort and style at every turn. Don't miss out—find your new home today at The Drake at Deerwood!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Jacksonville, FL",
  "property_seo_description_floorplans": "Discover your ideal living space at The Drake at Deerwood in Jacksonville, FL! Explore our thoughtfully designed floor plans, featuring one, two, and three-bedroom apartments. Whether you're seeking a cozy retreat or a spacious home, we have options to suit your lifestyle. Browse our available apartment homes today and find your perfect floor plan to fit your needs!",
  "property_seo_title_amenities": "Amenities | Jacksonville, FL Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury living at The Drake at Deerwood in Jacksonville, FL! Our community offers spacious one, two, and three-bedroom floor plans designed for comfort. Enjoy top-notch amenities like a modern fitness center, relaxing swimming pool, dog park, and inviting clubhouse. From American Landmark 360 finishes and crown molding to convenient car charging stations and outdoor kitchens, our apartments are tailored for your lifestyle. With beautiful lake views and online resident services for added convenience, it's time to elevate your living experience. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Jacksonville, FL",
  "property_seo_description_gallery": "Experience luxury living at The Drake at Deerwood in Jacksonville, FL! Explore our stunning photo gallery showcasing our spacious one, two, and three-bedroom floor plans. Enjoy top-notch amenities including a vast fitness center, swimming pool, dog park, and clubhouse. Picture yourself relaxing with lake views or entertaining in the outdoor kitchen. Discover the convenience of smart locks, W&D included, and online resident services. Your dream apartment awaits—dive into our gallery and start envisioning your new lifestyle today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Drake at Deerwood Apartments",
  "property_seo_description_virtualtours": "Explore the spacious floor plans at The Drake at Deerwood in Jacksonville, FL! From cozy one-bedroom layouts to expansive three-bedroom designs, we have the perfect apartment to fit your lifestyle. Take a virtual tour of our community and discover your dream home today!",
  "property_seo_title_interactivemap": "Interactive Map | The Drake at Deerwood Apartments",
  "property_seo_description_interactivemap": "Discover your ideal living space at The Drake at Deerwood in Jacksonville, FL! Explore our versatile floor plans—one, two, and three bedrooms—complete with upscale amenities like lake views, smart locks, and a state-of-the-art fitness center. Relax in our luxurious clubhouse or unwind by the swimming pool and outdoor kitchen. With facilities such as a dog park, volleyball court, and game room, you’ll find everything you need for a vibrant lifestyle. Use our interactive community map to view available apartments, check pricing, and find your perfect home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Jacksonville, FL",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding The Drake at Deerwood in Jacksonville, FL! Explore local favorites, nearby parks, dining, and entertainment options. See what's around our community and find your perfect home among our one, two, and three bedroom floor plans.",
  "property_seo_title_contact": "Contact Us | The Drake at Deerwood",
  "property_seo_description_contact": "Discover your perfect home at The Drake at Deerwood in Jacksonville, FL! Explore our spacious one, two, and three-bedroom floor plans designed for modern living. Have questions? Our leasing team is ready to assist you—contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Jacksonville, FL",
  "property_seo_description_faqs": "\"Discover your home at The Drake at Deerwood in Jacksonville, FL. Explore our spacious floor plans, featuring one, two, and three-bedroom options, complete with luxurious amenities like a fitness center, swimming pool, dog park, and lake views. Have questions? Browse our FAQs page for answers about our community, including details on smart locks, online resident services, and more. Your ideal apartment awaits!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Jacksonville, FL",
  "property_seo_description_reviews": "Explore the vibrant lifestyle at The Drake at Deerwood in Jacksonville, FL! With spacious one, two, and three-bedroom floor plans, our community offers exceptional amenities like a swimming pool, expansive fitness center, dog park, and clubhouse. Enjoy modern comforts such as smart locks, W&D included, and USB outlets, all while soaking in stunning lake views. Curious about life here? See what our residents have to say about their experience at our exceptional apartment community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Jacksonville, FL",
  "property_seo_description_applynow": "Discover your dream apartment at The Drake at Deerwood in Jacksonville, FL! Choose from spacious one, two, and three-bedroom floor plans, all featuring modern amenities like a clubhouse, expansive fitness center, and luxurious lake views. Enjoy exclusive perks like a dog park, car charging stations, and an outdoor kitchen, plus fun community features like a volleyball court and game room with billiards. With online resident services and smart locks for convenience, you’ll love coming home to The Drake. Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Drake at Deerwood",
  "property_seo_description_residentaccess": "\"Welcome to The Drake at Deerwood in Jacksonville, FL! Access your resident portal to easily pay rent, schedule maintenance, and enjoy a seamless living experience. Log in today and stay connected with your community!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Drake at Deerwood",
  "property_seo_description_referafriend": "\"Discover the perks of living at The Drake at Deerwood in Jacksonville, FL! Refer a friend today and enjoy great rewards—because great friends make great neighbors! Join our vibrant community and experience luxury living together.\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Drake at Deerwood",
  "property_seo_description_scheduletour": "Discover your new home at The Drake at Deerwood in Jacksonville, FL! Experience luxury living in our stunning apartments surrounded by beautiful amenities. Ready to find your perfect match? Schedule a tour of our community today!",
  "property_seo_title_privacy": "Privacy Policy | The Drake at Deerwood",
  "property_seo_description_privacy": "Discover how The Drake at Deerwood in Jacksonville, FL, prioritizes your privacy. Our comprehensive Privacy Policy outlines how we protect your personal information while providing you with a comfortable living experience. **View our privacy policy today!**",
  "property_seo_title_accessibility": "Website Accessibility | The Drake at Deerwood",
  "property_seo_description_accessibility": "Discover The Drake at Deerwood in Jacksonville, FL, where we prioritize accessibility for all. Our commitment to digital inclusion ensures that everyone can navigate our website effortlessly. Explore our comprehensive accessibility statement and learn how we support an inclusive community. Join us today!",
  "property_seo_title_sitemap": "Sitemap | The Drake at Deerwood",
  "property_seo_description_sitemap": "Discover a comprehensive overview of The Drake at Deerwood in Jacksonville, FL! Explore our sitemap to easily access community features, floor plans, and amenities. Navigate your new home with ease—view our sitemap today!",
  "property_seo_title_thankyou": "Thank You | The Drake at Deerwood",
  "property_seo_description_thankyou": "Thank you for reaching out to The Drake at Deerwood in Jacksonville, FL! Your inquiry is important to us. A member of our team will connect with you shortly to help you discover your perfect apartment home. Explore luxury living with top-notch amenities and a vibrant community. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651138662",
  "amenities": [
    {
      "id": "custom_e8953832-99b4-415a-8cb9-edd1fdacbb98",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d1c53d1-80af-41ac-9d4e-66848ec14eb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bfe993c2-dc39-40fa-bc30-5ace812ea0a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4074a7f1-2267-4f8f-8e65-f5d732e43430",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "Wall Outlets with USB Ports",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_239a22a7-384e-4379-9183-267bba7f1c74",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1d305157-7f97-4bf1-be5b-3fc892b032b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Upgraded Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae4bfa46-e662-4611-8c83-640b07828088",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_88a18605-84c6-4610-9e39-1812dce41ced",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000654",
      "title": "Lake Views",
      "amount": "0.0000",
      "description": "Beautiful Lake Views",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_48603788-8846-49e7-bec1-6e871f959591",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000683",
      "title": "Spacious Floor Plan",
      "amount": "0.0000",
      "description": "Open Concept Floor Plans",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_60758d60-ab08-4449-8f54-4854bded4b05",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ed71da35-6066-47f3-9534-a963c99fa583",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000002564",
      "title": "Closet Organizers",
      "amount": "0.0000",
      "description": "Closet Organizers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f737552-805a-46e6-84b9-2d793f49e984",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000624",
      "title": "Crown Molding",
      "amount": "0.0000",
      "description": "Decorative Crown Molding",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aece3d01-aab2-4d35-affa-93805ebad1a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000002480",
      "title": "Swimming Pool",
      "amount": "0.0000",
      "description": "Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e3e30d8c-a3b2-451a-9a89-e20d77a18431",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Car Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6e5963c1-9940-4a2c-a694-389183794cef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_695a8856-845d-48d8-bfa7-24be6d1ed894",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d66c47a8-04c9-41cf-85de-7ff06ffb1751",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fcb5bda3-c768-4bb1-8297-54efb9da53cc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Attached & Detached Garages Available",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_52a1dddd-5ad5-46f1-a8b9-963d88a24d94",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_00f0c9c4-32f8-4b05-8139-8d8deca04bfc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000701",
      "title": "Volleyball Court",
      "amount": "0.0000",
      "description": "Volleyball Court",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1be5bc6d-8954-4843-bf4b-4ac975f27007",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cabb9153-708f-4cfb-8cf0-48717834f3b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000002465",
      "title": "Expansive Fitness Center",
      "amount": "0.0000",
      "description": "Expansive Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b517bf25-fb19-4cc8-85c2-cbef7c47a94c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Community Summer Kitchen",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c4c4eb80-1eb1-4ea0-92fd-b77698d6fc90",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000002475",
      "title": "Game Room with Billiards",
      "amount": "0.0000",
      "description": "Game Room with Billiards",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_653070bc-c58e-4563-8e17-4ea1c8613342",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000002561",
      "title": "RentPlus",
      "amount": "0.0000",
      "description": "Credit Building powered by RentPlus",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_070d5a42-6300-44a7-a15e-1e86d557293a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000002562",
      "title": "Updater",
      "amount": "0.0000",
      "description": "Digital Moving Concierge Services by Updater",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_032b4e53-3461-4281-a869-8e0c0e10e52b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b984cd25-4688-4a50-be77-9054c5198489",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "external_id": "P000002563",
      "title": "Spruce",
      "amount": "0.0000",
      "description": "Hotel Inspired Housekeeping Services By Spruce",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_dae54329-9fd9-4a92-877a-13471e77e339",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-688b-7301-8646-de0bb3dae62a.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by trees.",
        "public_id": "019e89cb-688b-7301-8646-de0bb3dae62a",
        "storage_key": "property/6737460151191297/019e89cb-688b-7301-8646-de0bb3dae62a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with comfortable lounge chairs and umbrellas. Enjoy the resort-style amenities and lush surroundings.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02b841bd-49ee-445d-a4cd-b1f0363e39f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-64ce-75f6-819f-ddfa5769a8a9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, black granite countertops, and a bathtub with shower.",
        "public_id": "019e89cb-64ce-75f6-819f-ddfa5769a8a9",
        "storage_key": "property/6737460151191297/019e89cb-64ce-75f6-819f-ddfa5769a8a9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience luxury in our spacious bathrooms featuring elegant double vanities, granite countertops, and a relaxing bathtub with shower.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, black granite countertops, and a bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c99032e-df4c-4ffc-acb3-6569a358896c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-4e7b-777e-a2ed-2c894a53a507.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with waterfalls and lounge chairs.",
        "public_id": "019e89cb-4e7b-777e-a2ed-2c894a53a507",
        "storage_key": "property/6737460151191297/019e89cb-4e7b-777e-a2ed-2c894a53a507.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool, perfect for relaxing or entertaining. Features include cascading waterfalls, comfortable lounge chairs, and cabanas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with waterfalls and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9c92f809-4c0b-450e-986a-94462ba032ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-577f-7015-986b-2ab3095667e7.webp",
      "image_media": {
        "alt_text": "A spacious, modern fitness center with cardio machines and weight training equipment.",
        "public_id": "019e89cb-577f-7015-986b-2ab3095667e7",
        "storage_key": "property/6737460151191297/019e89cb-577f-7015-986b-2ab3095667e7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring state-of-the-art cardio machines and a comprehensive selection of weight training equipment.",
      "link": "",
      "alt_text": "A spacious, modern fitness center with cardio machines and weight training equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_54379eff-f448-4f82-81a8-68700de21158",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-4d55-727a-84e7-cb8915c233fd.webp",
      "image_media": {
        "alt_text": "Modern gym with TRX training zone, kettlebells, medicine ball, and plyo box.",
        "public_id": "019e89cb-4d55-727a-84e7-cb8915c233fd",
        "storage_key": "property/6737460151191297/019e89cb-4d55-727a-84e7-cb8915c233fd.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with a TRX training zone, free weights, and cardio equipment.",
      "link": "",
      "alt_text": "Modern gym with TRX training zone, kettlebells, medicine ball, and plyo box.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29279b17-4f94-4f6c-808f-f4d19be599af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-54cf-7790-b9b4-d9b3b2bb14e5.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a stone fireplace, contemporary artwork, and blue accent chairs.",
        "public_id": "019e89cb-54cf-7790-b9b4-d9b3b2bb14e5",
        "storage_key": "property/6737460151191297/019e89cb-54cf-7790-b9b4-d9b3b2bb14e5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a striking stone fireplace and comfortable seating.",
      "link": "",
      "alt_text": "Modern lounge area with a stone fireplace, contemporary artwork, and blue accent chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d805a7b-708b-4eb1-8f53-4cff70f513c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-4ae2-7617-bf24-8458493e59da.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with blue accents and floral wallpaper.",
        "public_id": "019e89cb-4ae2-7617-bf24-8458493e59da",
        "storage_key": "property/6737460151191297/019e89cb-4ae2-7617-bf24-8458493e59da.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish open-concept living and dining space featuring a cozy sectional, elegant dining set, and decorative shelving.",
      "link": "",
      "alt_text": "Modern living and dining area with blue accents and floral wallpaper.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8bb1e9de-7fad-48f6-8b5f-a8751cb93a3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-50e1-7768-ae2c-c2d754e7ef95.webp",
      "image_media": {
        "alt_text": "Outdoor hammocks and seating area with tables and umbrellas.",
        "public_id": "019e89cb-50e1-7768-ae2c-c2d754e7ef95",
        "storage_key": "property/6737460151191297/019e89cb-50e1-7768-ae2c-c2d754e7ef95.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable hammocks or gather with friends at the outdoor seating area, complete with tables and umbrellas.",
      "link": "",
      "alt_text": "Outdoor hammocks and seating area with tables and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7ba8e6f6-d23c-4da0-ae26-64f4fc9bec5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-4dc5-76ea-8b8e-e93f7e60409a.webp",
      "image_media": {
        "alt_text": "Master bedroom with a plush bed, modern abstract art, and views into the bathroom.",
        "public_id": "019e89cb-4dc5-76ea-8b8e-e93f7e60409a",
        "storage_key": "property/6737460151191297/019e89cb-4dc5-76ea-8b8e-e93f7e60409a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Unwind in a spacious master bedroom, featuring a comfortable bed, stylish decor, and convenient access to the en-suite bathroom.",
      "link": "",
      "alt_text": "Master bedroom with a plush bed, modern abstract art, and views into the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_997018bf-43a2-4aa7-b788-9d1c04c9b3b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-4764-743b-a978-11ecb926ac1e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and a large mirror.",
        "public_id": "019e89cb-4764-743b-a978-11ecb926ac1e",
        "storage_key": "property/6737460151191297/019e89cb-4764-743b-a978-11ecb926ac1e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious double vanity with granite countertops and a large vanity mirror, perfect for a relaxing start to your day.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, granite countertops, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3fa0470-2ce5-480b-9227-2cf9cb98728f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-4b14-75fb-bd21-e331b195d1a5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
        "public_id": "019e89cb-4b14-75fb-bd21-e331b195d1a5",
        "storage_key": "property/6737460151191297/019e89cb-4b14-75fb-bd21-e331b195d1a5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek kitchen, featuring granite countertops, stainless steel appliances, and ample cabinet space. Perfect for entertaining or a quick meal at the breakfast bar.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c925272c-34e3-4b15-8011-0e49c6b080ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-2bae-751b-a305-c6482151f2cf.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grills and hammocks",
        "public_id": "019e89cb-2bae-751b-a305-c6482151f2cf",
        "storage_key": "property/6737460151191297/019e89cb-2bae-751b-a305-c6482151f2cf.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community's grilling stations and relaxing hammock lounge, perfect for socializing or unwinding.",
      "link": "",
      "alt_text": "Outdoor seating area with grills and hammocks",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d52110e4-90ca-43da-afd4-acd89080f2a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-35ff-746c-ae63-c25410304857.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed and abstract art.",
        "public_id": "019e89cb-35ff-746c-ae63-c25410304857",
        "storage_key": "property/6737460151191297/019e89cb-35ff-746c-ae63-c25410304857.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush queen-size bed and striking abstract wall art.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dd190051-029c-4267-bb76-22ddbaa0dfd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-2972-7248-bce9-e27f3371a9d5.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, stair climbers, weight machines, and free weights.",
        "public_id": "019e89cb-2972-7248-bce9-e27f3371a9d5",
        "storage_key": "property/6737460151191297/019e89cb-2972-7248-bce9-e27f3371a9d5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, stair climbers, a full range of weight machines, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, stair climbers, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_25e9b8f2-16eb-4e6f-9cf3-885014a75937",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-271c-750b-8a98-c65936f60abd.webp",
      "image_media": {
        "alt_text": "Fitness center with turf flooring, weight machines, treadmills, and a tire sled.",
        "public_id": "019e89cb-271c-750b-8a98-c65936f60abd",
        "storage_key": "property/6737460151191297/019e89cb-271c-750b-8a98-c65936f60abd.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, free weights, and a dedicated training zone for all your workout needs.",
      "link": "",
      "alt_text": "Fitness center with turf flooring, weight machines, treadmills, and a tire sled.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_95bb86ee-9ec2-4cf2-88d2-ed04608158ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-3384-76ca-bcb3-82ca3bb43845.webp",
      "image_media": {
        "alt_text": "Fully equipped gym with turf flooring, TRX equipment, weights, and a large tractor tire.",
        "public_id": "019e89cb-3384-76ca-bcb3-82ca3bb43845",
        "storage_key": "property/6737460151191297/019e89cb-3384-76ca-bcb3-82ca3bb43845.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring turf flooring, cardio equipment, free weights, and functional training tools like TRX and a tractor tire for your workout.",
      "link": "",
      "alt_text": "Fully equipped gym with turf flooring, TRX equipment, weights, and a large tractor tire.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_551d12ec-980c-4491-958a-de0cb14cd13a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-2c7b-7599-adcc-37dd033c2cd4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and outdoor dining.",
        "public_id": "019e89cb-2c7b-7599-adcc-37dd033c2cd4",
        "storage_key": "property/6737460151191297/019e89cb-2c7b-7599-adcc-37dd033c2cd4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with comfortable lounge seating and convenient outdoor dining areas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and outdoor dining.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ef950ea7-e0bb-4514-ac89-44ac328b121b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-2963-70f2-93eb-f670d885c3c2.webp",
      "image_media": {
        "alt_text": "Washer and dryer set with a water heater above.",
        "public_id": "019e89cb-2963-70f2-93eb-f670d885c3c2",
        "storage_key": "property/6737460151191297/019e89cb-2963-70f2-93eb-f670d885c3c2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your laundry needs.",
      "link": "",
      "alt_text": "Washer and dryer set with a water heater above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9c41d5b-8e91-4ff3-a54a-fed56e4a23a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-2dab-770b-870b-95cff25a9f38.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a pass-through to the living room.",
        "public_id": "019e89cb-2dab-770b-870b-95cff25a9f38",
        "storage_key": "property/6737460151191297/019e89cb-2dab-770b-870b-95cff25a9f38.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white shaker cabinets, dark granite countertops, a deep double sink, stainless steel dishwasher, oven, microwave, and refrigerator. The open pass-through reveals a living area with a television.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a pass-through to the living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6275d3f7-acb9-404f-b348-477c53886c0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-2da6-77ec-a89e-e742c5c3d446.webp",
      "image_media": {
        "alt_text": "Modern lounge area with curved sectional sofa, black coffee table, and decorative accents.",
        "public_id": "019e89cb-2da6-77ec-a89e-e742c5c3d446",
        "storage_key": "property/6737460151191297/019e89cb-2da6-77ec-a89e-e742c5c3d446.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating and elegant decor. Perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Modern lounge area with curved sectional sofa, black coffee table, and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9134a95-5d8d-42bb-80fc-d81f2e11314d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-2a4b-7078-90df-7125260a6a36.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen area with grills and seating",
        "public_id": "019e89cb-2a4b-7078-90df-7125260a6a36",
        "storage_key": "property/6737460151191297/019e89cb-2a4b-7078-90df-7125260a6a36.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our spacious outdoor kitchen and seating area, perfect for gatherings and events.",
      "link": "",
      "alt_text": "Outdoor kitchen area with grills and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0bae6d8-24be-48fb-afa7-fd400ad7fc0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-1815-7279-a733-9afc390fb720.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, ottoman, entertainment center, and bookshelf.",
        "public_id": "019e89cb-1815-7279-a733-9afc390fb720",
        "storage_key": "property/6737460151191297/019e89cb-1815-7279-a733-9afc390fb720.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, modern coffee table, plush ottomans, and a sleek entertainment center, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, ottoman, entertainment center, and bookshelf.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6cd86c68-0972-4879-be8c-a20a70182d6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-10ca-709c-ab9b-5bc66c4b437a.webp",
      "image_media": {
        "alt_text": "Conference room with a long wooden table and blue chairs, a TV on the wall, and artwork.",
        "public_id": "019e89cb-10ca-709c-ab9b-5bc66c4b437a",
        "storage_key": "property/6737460151191297/019e89cb-10ca-709c-ab9b-5bc66c4b437a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Host your next meeting or event in our well-appointed conference room, featuring a large table, comfortable seating, and a modern aesthetic.",
      "link": "",
      "alt_text": "Conference room with a long wooden table and blue chairs, a TV on the wall, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f6082b98-7310-445a-a292-848940bf8408",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-0d0d-7299-ae2b-1bd5548d4846.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge seating under pergolas.",
        "public_id": "019e89cb-0d0d-7299-ae2b-1bd5548d4846",
        "storage_key": "property/6737460151191297/019e89cb-0d0d-7299-ae2b-1bd5548d4846.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by the resort-style pool, featuring comfortable lounge seating under shaded pergolas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge seating under pergolas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f16d1f63-e24e-4b51-8ae1-c64202c58984",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-0e5d-71af-a20b-43312946a240.webp",
      "image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island and bar stools.",
        "public_id": "019e89cb-0e5d-71af-a20b-43312946a240",
        "storage_key": "property/6737460151191297/019e89cb-0e5d-71af-a20b-43312946a240.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish open-concept living and dining area featuring a modern kitchen island with bar stools, comfortable seating, and a decorative accent wall.",
      "link": "",
      "alt_text": "Open concept living and dining area with a kitchen island and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4f9c5780-fef5-483c-a163-1e975ddbda41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e89cb-089e-715e-af6e-393ac6487fca.webp",
      "image_media": {
        "alt_text": "Community lounge area with bar seating and modern decor.",
        "public_id": "019e89cb-089e-715e-af6e-393ac6487fca",
        "storage_key": "property/6737460151191297/019e89cb-089e-715e-af6e-393ac6487fca.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stylish community lounge featuring a sleek bar with counter stools, comfortable seating, and decorative accents.",
      "link": "",
      "alt_text": "Community lounge area with bar seating and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_c38dadeda8e32cd7c822fae5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Cantina Louie (Jacksonville/Southside, FL)",
      "poi_type": "Restaurants",
      "poi_address": "9726 Touchton Rd #105, Jacksonville, FL 32246, USA",
      "poi_short_description": "Mexican restaurant serving favorites such as quesadillas and fajitas, plus margaritas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-ac55-7032-a1a9-5c16822506ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-ac55-7032-a1a9-5c16822506ad",
        "storage_key": "property/6737460151191297/019f14e7-ac55-7032-a1a9-5c16822506ad.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cantinalouie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10062642732191386311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cantina-louie-jacksonvillesouthside-fl",
      "poi_latitude": "30.2679886",
      "poi_longitude": "-81.55519009999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-329-4369",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qaQ3e15YgRxwrvMUCwpYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_0fad6251ddad896324a97de6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Vagabond Korean BBQ",
      "poi_type": "Restaurants",
      "poi_address": "9726 Touchton Rd Ste 108, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-b291-7359-9ea8-ddb0a373ef48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-b291-7359-9ea8-ddb0a373ef48",
        "storage_key": "property/6737460151191297/019f14e7-b291-7359-9ea8-ddb0a373ef48.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://vagabondkoreansteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6338867536191734877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vagabond-korean-bbq",
      "poi_latitude": "30.2678336",
      "poi_longitude": "-81.5551492",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 904-518-5089",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZTWbRv215YgRXcT2fHAu-Fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_barbecue_restaurant"
    },
    {
      "id": "ec_2118d567789d652779860fd5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Miller's Ale House",
      "poi_type": "Restaurants",
      "poi_address": "9711 Deer Lake Ct, Jacksonville, FL 32246, USA",
      "poi_short_description": "Casual sports-pub chain with basics from bar snacks to steaks & a large selection of tap beers.",
      "poi_long_description": "Casual sports-pub chain with basics from bar snacks to steaks & a large selection of tap beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-b1c8-75b9-a9e4-901e360fa65e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-b1c8-75b9-a9e4-901e360fa65e",
        "storage_key": "property/6737460151191297/019f14e7-b1c8-75b9-a9e4-901e360fa65e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://millersalehouse.com/locations/jacksonville-southside/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=11444725647615948305&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "millers-ale-house",
      "poi_latitude": "30.2657309",
      "poi_longitude": "-81.556386",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-565-2882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69vdu3m15YgREXbz-VbV054",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_7c4513832e424d6ce6453c1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "4907 Gate Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-ad80-7018-ac09-7972dd37217f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-ad80-7018-ac09-7972dd37217f",
        "storage_key": "property/6737460151191297/019f14e7-ad80-7018-ac09-7972dd37217f.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/fl/jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=3674706219497040796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "30.2521041",
      "poi_longitude": "-81.53534359999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-998-0460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ08mhJ6LK5YgRnCsKU9Yt_zI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_14ed02859dfd8191fe582176",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "V Pizza + Sidecar",
      "poi_type": "Restaurants",
      "poi_address": "7510 Gate Pkwy, Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-b110-7316-ab2b-891c46a9735c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-b110-7316-ab2b-891c46a9735c",
        "storage_key": "property/6737460151191297/019f14e7-b110-7316-ab2b-891c46a9735c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://vpizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11224800647212887337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "v-pizza--sidecar",
      "poi_latitude": "30.2440513",
      "poi_longitude": "-81.5209642",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-431-0833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3rE6lTL5YgRKe2yk7eAxps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_f07c996e54c5858a5e85386d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Lucky Goat Coffee",
      "poi_type": "Restaurants",
      "poi_address": "10618 Deerwood Park Blvd #1, Jacksonville, FL 32256, USA",
      "poi_short_description": "Casual place for made-to-order coffees and lattes, plus cold-brew varieties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-b7c0-733b-89c7-7eb88631c75d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-b7c0-733b-89c7-7eb88631c75d",
        "storage_key": "property/6737460151191297/019f14e7-b7c0-733b-89c7-7eb88631c75d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://luckygoatcoffee.com/pages/deerwood-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6667687375078576677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-goat-coffee",
      "poi_latitude": "30.24723329999999",
      "poi_longitude": "-81.537657",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-518-6139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-9980-7768-b695-3cc817734ab1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-9980-7768-b695-3cc817734ab1",
        "storage_key": "property/6737460151191297/019f14e8-9980-7768-b695-3cc817734ab1.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ58CvUJHL5YgRJVLqOFdiiFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_74d95054f1101fb8c2611711",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Mechanism Coffee Roasters",
      "poi_type": "Restaurants",
      "poi_address": "11526 Lake Mead Ave Ste 103, Jacksonville, FL 32256, USA",
      "poi_short_description": "Casual coffeehouse featuring specialty roasts, plus espresso drinks, bagels, and breakfast burritos.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-b369-7133-b5d7-937f52c87bd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-b369-7133-b5d7-937f52c87bd0",
        "storage_key": "property/6737460151191297/019f14e7-b369-7133-b5d7-937f52c87bd0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.mechanismcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1938225826846839762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mechanism-coffee-roasters",
      "poi_latitude": "30.2315776",
      "poi_longitude": "-81.5109087",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-619-2657",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-9980-7768-b695-3cc817734ab1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-9980-7768-b695-3cc817734ab1",
        "storage_key": "property/6737460151191297/019f14e8-9980-7768-b695-3cc817734ab1.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJV5GLaw015IgR0pOxzx725Ro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_0e00fa865203d7b426f505f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Maggiano's Little Italy",
      "poi_type": "Restaurants",
      "poi_address": "St. Johns Town Center, 10367 Mid Town Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Semi-upscale chain for classic Italian fare served family-style in a relaxed, polished space.",
      "poi_long_description": "Semi-upscale chain for classic Italian fare served family-style in a relaxed, polished space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-ae57-729e-bea4-d74aadcaef65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-ae57-729e-bea4-d74aadcaef65",
        "storage_key": "property/6737460151191297/019f14e7-ae57-729e-bea4-d74aadcaef65.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.maggianos.com/locations/florida/jacksonville/10367-midtown-pkwy/?utm_source=google&utm_medium=organic&utm_campaign=Maggianos",
      "poi_directions_map_url": "https://maps.google.com/?cid=1571101166876324053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maggianos-little-italy",
      "poi_latitude": "30.2579949",
      "poi_longitude": "-81.525182",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-380-4360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1_rKPFe15YgR1XDd7S-szRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_bb4f06bf89d728c768e20e34",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Fogo de Chão Brazilian Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "4784 Town Center Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_long_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-b410-714a-ac05-8d8931624167.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-b410-714a-ac05-8d8931624167",
        "storage_key": "property/6737460151191297/019f14e7-b410-714a-ac05-8d8931624167.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fogodechao.com/location/jacksonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3742935822459690057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fogo-de-cho-brazilian-steakhouse",
      "poi_latitude": "30.256109",
      "poi_longitude": "-81.5302763",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-512-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRwPY81i15YgRSVzLskyU8TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "ec_31eb935d99e8426a054d8780",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Firebirds Wood Fired Grill",
      "poi_type": "Restaurants",
      "poi_address": "4826 Town Center Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_long_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-b5c1-76bc-afd7-93332dec895d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-b5c1-76bc-afd7-93332dec895d",
        "storage_key": "property/6737460151191297/019f14e7-b5c1-76bc-afd7-93332dec895d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://firebirdsrestaurants.com/jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=9857029493669421296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firebirds-wood-fired-grill",
      "poi_latitude": "30.2556381",
      "poi_longitude": "-81.5312481",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-831-3950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSzVNvli15YgR8OC2hhk0y4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_fd06a9e5e0829fc1598a19ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Cooper’s Hawk Winery & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4850 Big Island Drive, Jacksonville, FL 32246, USA",
      "poi_short_description": "Upscale chain serving New American fare paired with house-label  wines in a contemporary setting.",
      "poi_long_description": "Upscale chain serving New American fare paired with house-label  wines in a contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-bfdc-72dc-85ff-812332161dcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-bfdc-72dc-85ff-812332161dcc",
        "storage_key": "property/6737460151191297/019f14e7-bfdc-72dc-85ff-812332161dcc.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://chwinery.com/locations/florida/jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=7584820276312280155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coopers-hawk-winery--restaurant",
      "poi_latitude": "30.2533756",
      "poi_longitude": "-81.5310576",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-559-4999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJQBDXqfK5YgRWwzG7tqxQmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_2acb9fdccecd30a9803a29b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "4586 Town Center Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-b8e4-77c3-aff3-b60777b47a04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-b8e4-77c3-aff3-b60777b47a04",
        "storage_key": "property/6737460151191297/019f14e7-b8e4-77c3-aff3-b60777b47a04.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/fl/jacksonville/st-johns-738",
      "poi_directions_map_url": "https://maps.google.com/?cid=15313845834368356785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "30.260949",
      "poi_longitude": "-81.5299948",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-713-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaRUKNlq15YgRsRGfbqa1hdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_e1ba4dc1b21477806a40cbf7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Hopdoddy Burger Bar",
      "poi_type": "Restaurants",
      "poi_address": "4906 Town Center Pkwy Unit 408, Jacksonville, FL 32246, USA",
      "poi_short_description": "Modern outfit for gourmet burgers & nonbeef options, plus spiked milkshakes & creative cocktails.",
      "poi_long_description": "Modern outfit for gourmet burgers & nonbeef options, plus spiked milkshakes & creative cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-c56e-7159-a5cf-af1bd1243dc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-c56e-7159-a5cf-af1bd1243dc2",
        "storage_key": "property/6737460151191297/019f14e7-c56e-7159-a5cf-af1bd1243dc2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hopdoddy.com/locations/jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=4562872551682300500&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hopdoddy-burger-bar",
      "poi_latitude": "30.2564922",
      "poi_longitude": "-81.53452419999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-562-2828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSK4qV-15YgRVFpnHmmUUj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_fcd151f5c6ca4f04d9518269",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Kazu Sushi Burrito",
      "poi_type": "Restaurants",
      "poi_address": "4600 Tropea Wy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Sushi spot serving custom-filled burritos and bowls alongside appetizers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-cf91-7684-bc48-d62078d84f84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-cf91-7684-bc48-d62078d84f84",
        "storage_key": "property/6737460151191297/019f14e7-cf91-7684-bc48-d62078d84f84.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kazutowncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7018198657855696017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kazu-sushi-burrito",
      "poi_latitude": "30.2601824",
      "poi_longitude": "-81.5305541",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-219-7766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsW07Ece15YgRkayczH6mZWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_edc6ebbd0b001f20b8f8c517",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "4578 Tropea Wy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e4-df77-77ea-835a-2508d449061a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-df77-77ea-835a-2508d449061a",
        "storage_key": "property/6737460151191297/019f14e4-df77-77ea-835a-2508d449061a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/florida/jacksonville?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=18141132104530571548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "30.2612857",
      "poi_longitude": "-81.53051669999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-641-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0xoplu15YgRHLH6gYg_wvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_f6e4bc687961788349ba82cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Publix Super Market at St. John's Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "4413 Town Center Pkwy #100, Jacksonville, FL 32246, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-c7a6-77ee-92fc-10278a72781f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-c7a6-77ee-92fc-10278a72781f",
        "storage_key": "property/6737460151191297/019f14e7-c7a6-77ee-92fc-10278a72781f.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1125&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=17040965378156256864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-st-johns-town-center",
      "poi_latitude": "30.264259",
      "poi_longitude": "-81.5264602",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-564-3632",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62ba-707d-afda-c4ca796bbf3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62ba-707d-afda-c4ca796bbf3b",
        "storage_key": "property/6737460151191297/019f14e5-62ba-707d-afda-c4ca796bbf3b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZsOUUW15YgRYN67ermrfew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_b3aeba1c397fe0730d403de9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "4893 Town Center Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-c8d2-76bc-a6cc-b7b1f19ecf09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-c8d2-76bc-a6cc-b7b1f19ecf09",
        "storage_key": "property/6737460151191297/019f14e7-c8d2-76bc-a6cc-b7b1f19ecf09.webp",
        "width": 1280,
        "height": 987
      },
      "poi_business_url": "https://www.cvs.com/store-locator/jacksonville-fl-pharmacies/4893-town-center-parkway-jacksonville-fl-32246/storeid=8902?WT.mc_id=LS_GOOGLE_FS_8902",
      "poi_directions_map_url": "https://maps.google.com/?cid=15665363148135295600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "30.2541482",
      "poi_longitude": "-81.5353868",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-642-2442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn4Vl8Vi15YgRcGoZ2siMZtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_45b382eaccd6bacd61745a16",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "4901 Gate Pkwy #357b, Jacksonville, FL 32246, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-cd24-71fa-81e8-9a0a8563ff55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-cd24-71fa-81e8-9a0a8563ff55",
        "storage_key": "property/6737460151191297/019f14e7-cd24-71fa-81e8-9a0a8563ff55.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/jacksonville-FL-357.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4318056365048931736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "30.2516046",
      "poi_longitude": "-81.5334151",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-997-7003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62c3-729e-80e7-aae66512cc6b",
        "storage_key": "property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnUML6aDK5YgRmCXbzmLR7Ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "ec_1cb6b48251213f1b426dc0fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "4866 Gate Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-c67b-76bc-84dd-dca5b34d4015.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-c67b-76bc-84dd-dca5b34d4015",
        "storage_key": "property/6737460151191297/019f14e7-c67b-76bc-84dd-dca5b34d4015.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/5257?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=15749704394058546376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "30.2537166",
      "poi_longitude": "-81.5366715",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-900-7690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh9P3CaDK5YgRyLxEbbMwkto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_ab2b2d3aa8a6cb1ba76ad1eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "4567 River City Dr, Jacksonville, FL 32246, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-ca61-759c-a953-8246d4a55e37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-ca61-759c-a953-8246d4a55e37",
        "storage_key": "property/6737460151191297/019f14e7-ca61-759c-a953-8246d4a55e37.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/jacksonville-st-johns/1974",
      "poi_directions_map_url": "https://maps.google.com/?cid=17370927936033891123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "30.260905",
      "poi_longitude": "-81.524412",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-596-0020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62c3-729e-80e7-aae66512cc6b",
        "storage_key": "property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJbj0P1e15YgRM6M1NuzuEfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_80117b629dae33f66a12eb7b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "St. Johns Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "4663 River City Dr, Jacksonville, FL 32246, USA",
      "poi_short_description": "Outdoor mall with known fashion, home goods & electronics brands, sit-down dining & quick snacks.",
      "poi_long_description": "Outdoor mall with known fashion, home goods & electronics brands, sit-down dining & quick snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e4-dd43-74ae-9771-2d31f80afcb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-dd43-74ae-9771-2d31f80afcb1",
        "storage_key": "property/6737460151191297/019f14e4-dd43-74ae-9771-2d31f80afcb1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.simon.com/mall/st-johns-town-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=18063775443598808474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-johns-town-center",
      "poi_latitude": "30.2568706",
      "poi_longitude": "-81.5253244",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-998-7156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62c3-729e-80e7-aae66512cc6b",
        "storage_key": "property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFX_HOVe15YgRmpUhWg9sr_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_ec2c253ec1a4baa7189060bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Total Wine & More",
      "poi_type": "Shopping & Retail",
      "poi_address": "4413 Town Center Pkwy Ste 300, Jacksonville, FL 32246, USA",
      "poi_short_description": "Family-owned chain retailer offering a wide selection of wine, beer & spirits.",
      "poi_long_description": "Family-owned chain retailer offering a wide selection of wine, beer & spirits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-cccd-70d9-8f07-d29b54ac2e3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-cccd-70d9-8f07-d29b54ac2e3a",
        "storage_key": "property/6737460151191297/019f14e7-cccd-70d9-8f07-d29b54ac2e3a.webp",
        "width": 570,
        "height": 317
      },
      "poi_business_url": "https://www.totalwine.com/store-info/florida-jacksonville/907?cid=referral:website_link::momentfeed:907_jacksonville_store_details_page:",
      "poi_directions_map_url": "https://maps.google.com/?cid=18094799531358180342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "total-wine--more",
      "poi_latitude": "30.2628032",
      "poi_longitude": "-81.526887",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-998-1740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62c3-729e-80e7-aae66512cc6b",
        "storage_key": "property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLZsOUUW15YgR9lOCrE2kHfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "ec_65891b6fcfe09df58a36e36a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "7801 Gate Pkwy, Jacksonville, FL 32256, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e4-ddb6-719d-8134-1e31f6fb2d71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-ddb6-719d-8134-1e31f6fb2d71",
        "storage_key": "property/6737460151191297/019f14e4-ddb6-719d-8134-1e31f6fb2d71.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/jacksonville/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=1842684368552300310&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "30.2373851",
      "poi_longitude": "-81.5165329",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62c3-729e-80e7-aae66512cc6b",
        "storage_key": "property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVQQCMLPK5YgRFo-5lKuHkhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_03892e14e8fc315f18a8682a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "The Avenues",
      "poi_type": "Shopping & Retail",
      "poi_address": "10300 Southside Blvd, Jacksonville, FL 32256, USA",
      "poi_short_description": "Bright, modern mall features familiar big-box stores, clothing boutiques, restaurants & a wine bar.",
      "poi_long_description": "Bright, modern mall features familiar big-box stores, clothing boutiques, restaurants & a wine bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e4-e3e9-71ae-9847-d0a75f97a6b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-e3e9-71ae-9847-d0a75f97a6b0",
        "storage_key": "property/6737460151191297/019f14e4-e3e9-71ae-9847-d0a75f97a6b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/the-avenues",
      "poi_directions_map_url": "https://maps.google.com/?cid=10488048585255883970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-avenues",
      "poi_latitude": "30.184439",
      "poi_longitude": "-81.554024",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 904-363-3060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62c3-729e-80e7-aae66512cc6b",
        "storage_key": "property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjQlbVnPL5YgRwhQ3x54IjZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_0f15dc7347ebcaa1112691db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "11430 Beach Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-d6f7-702d-abbd-2398a111ab9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-d6f7-702d-abbd-2398a111ab9e",
        "storage_key": "property/6737460151191297/019f14e7-d6f7-702d-abbd-2398a111ab9e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-11430+beach+blvd-jacksonville-fl-32246/id=5129",
      "poi_directions_map_url": "https://maps.google.com/?cid=9172666211581893522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.28622529999999",
      "poi_longitude": "-81.52486320000001",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-641-1581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYmoODC15YgRkhuREFLbS38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_0ed089c9ce27627f6e8f34ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Hogan-Spring Glen Elementary School",
      "poi_type": "Education",
      "poi_address": "6736 Beach Blvd, Jacksonville, FL 32216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.duvalschools.org/hsg",
      "poi_directions_map_url": "https://maps.google.com/?cid=3449445742288297391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hogan-spring-glen-elementary-school",
      "poi_latitude": "30.2890067",
      "poi_longitude": "-81.5895874",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-720-1640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62b5-735f-81b9-09e25764d63a",
        "storage_key": "property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWxax88S15YgRr90TbaDk3i8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_f10414919fa0fc86aa31957c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Twin Lakes Academy Middle School",
      "poi_type": "Education",
      "poi_address": "8050 Point Meadows Dr, Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-d47f-7118-b6a6-14745b455592.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-d47f-7118-b6a6-14745b455592",
        "storage_key": "property/6737460151191297/019f14e7-d47f-7118-b6a6-14745b455592.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.duvalschools.org/tlam",
      "poi_directions_map_url": "https://maps.google.com/?cid=18134562247312556594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twin-lakes-academy-middle-school",
      "poi_latitude": "30.2220985",
      "poi_longitude": "-81.5158392",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-538-0825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62b5-735f-81b9-09e25764d63a",
        "storage_key": "property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcdpFRDM15IgRMkJGbEjoqvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_6e5be63e0206e83175a1195b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Englewood High School",
      "poi_type": "Education",
      "poi_address": "4412 Barnes Rd S, Jacksonville, FL 32207, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-e1fb-7542-beaa-aba108c1980f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-e1fb-7542-beaa-aba108c1980f",
        "storage_key": "property/6737460151191297/019f14e7-e1fb-7542-beaa-aba108c1980f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.duvalschools.org/ehs",
      "poi_directions_map_url": "https://maps.google.com/?cid=2987702014357807068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "englewood-high-school",
      "poi_latitude": "30.2780664",
      "poi_longitude": "-81.61073520000001",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-739-5212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62b5-735f-81b9-09e25764d63a",
        "storage_key": "property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi6Z8bwy25YgR3B-EDCdzdik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_ac2609a01fa601aafefcadb5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Sandalwood High School",
      "poi_type": "Education",
      "poi_address": "2750 John Prom Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-dd7b-706a-8b17-611c93dcdabe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-dd7b-706a-8b17-611c93dcdabe",
        "storage_key": "property/6737460151191297/019f14e7-dd7b-706a-8b17-611c93dcdabe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.duvalschools.org/sandalwood",
      "poi_directions_map_url": "https://maps.google.com/?cid=6900108786322991883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sandalwood-high-school",
      "poi_latitude": "30.2970504",
      "poi_longitude": "-81.5178626",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-646-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62b5-735f-81b9-09e25764d63a",
        "storage_key": "property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo6jfkiq15YgRC2tVAGIcwl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_e599e6218249c703b242b55c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Atlantic Coast High School",
      "poi_type": "Education",
      "poi_address": "9735 R G Skinner Pkwy, Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-dcda-71fb-bfed-c3e9bd105706.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-dcda-71fb-bfed-c3e9bd105706",
        "storage_key": "property/6737460151191297/019f14e7-dcda-71fb-bfed-c3e9bd105706.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.duvalschools.org/o/achs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6050175158719638214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlantic-coast-high-school",
      "poi_latitude": "30.2027944",
      "poi_longitude": "-81.5061755",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-538-5120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62b5-735f-81b9-09e25764d63a",
        "storage_key": "property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs0NXDdc05IgRxmpgbECK9lM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_b600f6d6d9c71b1a32fee5b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "KidsPark - JAX",
      "poi_type": "Education",
      "poi_address": "9726 Touchton Rd Ste 111, Jacksonville, FL 32246, USA",
      "poi_short_description": "Kid -friendly center featuring hourly pay-as-you-play care, plus activities and crafts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-d889-70ba-adca-c623b3d15f88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-d889-70ba-adca-c623b3d15f88",
        "storage_key": "property/6737460151191297/019f14e7-d889-70ba-adca-c623b3d15f88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kidspark.com/find-your-center/our-locations/florida/touchton-center-fl/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6801945027591177828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kidspark---jax",
      "poi_latitude": "30.2674304",
      "poi_longitude": "-81.5552622",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 904-683-4554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62b5-735f-81b9-09e25764d63a",
        "storage_key": "property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1yyoXHe15YgRZIZO3_ZcZV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_89d6300a2f5c478155d8b123",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "A Bright Beginning Childcare",
      "poi_type": "Education",
      "poi_address": "9762 Deer Lake Ct, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-df13-748f-a3ea-3572dde9d1bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-df13-748f-a3ea-3572dde9d1bf",
        "storage_key": "property/6737460151191297/019f14e7-df13-748f-a3ea-3572dde9d1bf.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://abrightbeginningchildcarejax.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16507247144888263929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-bright-beginning-childcare",
      "poi_latitude": "30.2664606",
      "poi_longitude": "-81.5540347",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 904-606-9242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62b5-735f-81b9-09e25764d63a",
        "storage_key": "property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkwBV-Xm15YgR-WSlstGFFeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_d2a866100762ce5b56ba117b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Rattles to Tassels Learning Center",
      "poi_type": "Education",
      "poi_address": "9701 Anders Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-dff2-74ba-9d95-c767d41e2aee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-dff2-74ba-9d95-c767d41e2aee",
        "storage_key": "property/6737460151191297/019f14e7-dff2-74ba-9d95-c767d41e2aee.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rattlestotassels.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12024523272312826708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rattles-to-tassels-learning-center",
      "poi_latitude": "30.278269",
      "poi_longitude": "-81.55835300000001",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-619-4702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62b5-735f-81b9-09e25764d63a",
        "storage_key": "property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbx5gSnW15YgRVKufHzWw36Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_84635721419eec8793c318d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "FSCJ Deerwood Center",
      "poi_type": "Education",
      "poi_address": "9911 Old Baymeadows Rd, Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e4-e9a6-7483-9203-2c6f2ce32d7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-e9a6-7483-9203-2c6f2ce32d7c",
        "storage_key": "property/6737460151191297/019f14e4-e9a6-7483-9203-2c6f2ce32d7c.webp",
        "width": 970,
        "height": 1280
      },
      "poi_business_url": "https://www.fscj.edu/campuses/deerwood-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=15619238271498864099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fscj-deerwood-center",
      "poi_latitude": "30.22186629999999",
      "poi_longitude": "-81.5537294",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-646-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62b5-735f-81b9-09e25764d63a",
        "storage_key": "property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq6pqsfDK5YgR40XgInSuwtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_a07faf27d5d72452c8da482d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "University of North Florida (UNF)",
      "poi_type": "Education",
      "poi_address": "1 UNF Dr., Jacksonville, FL 32224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e4-e953-7421-8020-128a645d1e58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-e953-7421-8020-128a645d1e58",
        "storage_key": "property/6737460151191297/019f14e4-e953-7421-8020-128a645d1e58.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.unf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18226157899370904914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-florida-unf",
      "poi_latitude": "30.2661204",
      "poi_longitude": "-81.50723140000001",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-620-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62b5-735f-81b9-09e25764d63a",
        "storage_key": "property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU2DTHbRK5IgRUr0uDAtS8Pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_d686625890663cf0e33360d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Topgolf Jacksonville",
      "poi_type": "Entertainment",
      "poi_address": "10531 Brightman Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e4-dad8-7051-9a40-3b159c2356a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-dad8-7051-9a40-3b159c2356a1",
        "storage_key": "property/6737460151191297/019f14e4-dad8-7051-9a40-3b159c2356a1.webp",
        "width": 1000,
        "height": 720
      },
      "poi_business_url": "https://topgolf.com/us/jacksonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=551425716930125462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-jacksonville",
      "poi_latitude": "30.2632674",
      "poi_longitude": "-81.5205175",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-328-2002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6012-7106-9ebf-688d1d067a58",
        "storage_key": "property/6737460151191297/019f14e5-6012-7106-9ebf-688d1d067a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUWBGFK15YgRlp6imcQOpwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_b433d3fa8eb36b8468d92c5f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "iFLY Indoor Skydiving - Jacksonville",
      "poi_type": "Entertainment",
      "poi_address": "10579 Brightman Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "Indoor simulated skydiving attraction featuring wind tunnels, instructors and lessons.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-e75a-7739-8ae5-2f0725cb3134.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-e75a-7739-8ae5-2f0725cb3134",
        "storage_key": "property/6737460151191297/019f14e7-e75a-7739-8ae5-2f0725cb3134.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.iflyworld.com/jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=16132727053829362004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ifly-indoor-skydiving---jacksonville",
      "poi_latitude": "30.2614347",
      "poi_longitude": "-81.5195683",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-712-3388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-YiI_-215YgRVFHV1cf14t8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_d3305ac5282dfb4391817d95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "St. Johns Town Center",
      "poi_type": "Entertainment",
      "poi_address": "4663 River City Dr, Jacksonville, FL 32246, USA",
      "poi_short_description": "Outdoor mall with known fashion, home goods & electronics brands, sit-down dining & quick snacks.",
      "poi_long_description": "Outdoor mall with known fashion, home goods & electronics brands, sit-down dining & quick snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e4-dd43-74ae-9771-2d31f80afcb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-dd43-74ae-9771-2d31f80afcb1",
        "storage_key": "property/6737460151191297/019f14e4-dd43-74ae-9771-2d31f80afcb1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.simon.com/mall/st-johns-town-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=18063775443598808474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-johns-town-center",
      "poi_latitude": "30.2568706",
      "poi_longitude": "-81.5253244",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-998-7156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62c3-729e-80e7-aae66512cc6b",
        "storage_key": "property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFX_HOVe15YgRmpUhWg9sr_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_b494cac6aaf3b755bee1738a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Regal Avenues",
      "poi_type": "Entertainment",
      "poi_address": "9525 Philips Hwy, Jacksonville, FL 32256, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-e765-743d-acc5-de9a02b793d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-e765-743d-acc5-de9a02b793d2",
        "storage_key": "property/6737460151191297/019f14e7-e765-743d-acc5-de9a02b793d2.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-avenues-4dx-rpx-0241?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15602395788785793452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-avenues",
      "poi_latitude": "30.19236369999999",
      "poi_longitude": "-81.5648355",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-9963-752f-8ea2-3d4886f4551a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-9963-752f-8ea2-3d4886f4551a",
        "storage_key": "property/6737460151191297/019f14e8-9963-752f-8ea2-3d4886f4551a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7VPq_aPL5YgRrLmgC07Yhtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_13a5826f9c1b348d07987d05",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "AMC Regency 24",
      "poi_type": "Entertainment",
      "poi_address": "9451 Regency Square Blvd, Jacksonville, FL 32225, USA",
      "poi_short_description": "Movie theater chain in the Regency Square Mall offering 3D and IMAX films, plus reclining seats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-eb4e-7784-b5cf-40d5144747fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-eb4e-7784-b5cf-40d5144747fc",
        "storage_key": "property/6737460151191297/019f14e7-eb4e-7784-b5cf-40d5144747fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/jacksonville/amc-regency-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5981426088109745154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-regency-24",
      "poi_latitude": "30.3269945",
      "poi_longitude": "-81.5548534",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-725-0885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-9963-752f-8ea2-3d4886f4551a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-9963-752f-8ea2-3d4886f4551a",
        "storage_key": "property/6737460151191297/019f14e8-9963-752f-8ea2-3d4886f4551a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJMUfYhYy05YgRAiQJEFZLAlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_a76bf74bf78541462e0b0a7a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Cummer Museum of Art & Gardens",
      "poi_type": "Entertainment",
      "poi_address": "829 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "Museum showcases 5,000 works of art from all eras in a riverfront site surrounded by gardens.",
      "poi_long_description": "Museum showcases 5,000 works of art from all eras in a riverfront site surrounded by gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-e870-741b-b1ae-d350fb263161.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-e870-741b-b1ae-d350fb263161",
        "storage_key": "property/6737460151191297/019f14e7-e870-741b-b1ae-d350fb263161.webp",
        "width": 640,
        "height": 426
      },
      "poi_business_url": "http://www.cummermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1730978020932146253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cummer-museum-of-art--gardens",
      "poi_latitude": "30.3150334",
      "poi_longitude": "-81.6766992",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 904-356-6857",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6078-7327-b86f-682c469326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6078-7327-b86f-682c469326e5",
        "storage_key": "property/6737460151191297/019f14e5-6078-7327-b86f-682c469326e5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJrbZAOHG35YgRTVSrw1arBRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_cbbd70c0af6ad7c235121ea5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "MOSH (Museum Of Science & History)",
      "poi_type": "Entertainment",
      "poi_address": "1025 Museum Cir, Jacksonville, FL 32207, USA",
      "poi_short_description": "Aquariums & exhibits on the body, marine mammals & energy are featured at this popular museum.",
      "poi_long_description": "Aquariums & exhibits on the body, marine mammals & energy are featured at this popular museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-ef79-7284-aead-5d78264d9118.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-ef79-7284-aead-5d78264d9118",
        "storage_key": "property/6737460151191297/019f14e7-ef79-7284-aead-5d78264d9118.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://themosh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7369837136756052471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mosh-museum-of-science--history",
      "poi_latitude": "30.31886519999999",
      "poi_longitude": "-81.65976669999999",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 904-396-6674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6078-7327-b86f-682c469326e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6078-7327-b86f-682c469326e5",
        "storage_key": "property/6737460151191297/019f14e5-6078-7327-b86f-682c469326e5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1gEIRC35YgR95HTLNTrRmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_75f7548543384d9eb272566c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Riverside Arts Market",
      "poi_type": "Entertainment",
      "poi_address": "715 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "Lively market held Saturdays under the bridge featuring local artists, food vendors & entertainment.",
      "poi_long_description": "Lively market held Saturdays under the bridge featuring local artists, food vendors & entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-f051-718a-8fe7-0fa7bb469099.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-f051-718a-8fe7-0fa7bb469099",
        "storage_key": "property/6737460151191297/019f14e7-f051-718a-8fe7-0fa7bb469099.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://riversideartsmarket.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=214201419467524069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-arts-market",
      "poi_latitude": "30.316298",
      "poi_longitude": "-81.6756949",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 904-389-2449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62c3-729e-80e7-aae66512cc6b",
        "storage_key": "property/6737460151191297/019f14e5-62c3-729e-80e7-aae66512cc6b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTZDpDXG35YgR5Qe_XQ7_-AI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "ec_ee3871a486bba4cefdb6fdc3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Jacksonville Zoo and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "370 Zoo Pkwy, Jacksonville, FL 32218, USA",
      "poi_short_description": "Vast zoo highlighting local as well as African wildlife with gardens, a train & a kids' zone.",
      "poi_long_description": "Vast zoo highlighting local as well as African wildlife with gardens, a train & a kids' zone.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-ed33-714a-8fa5-7b3b6258559b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-ed33-714a-8fa5-7b3b6258559b",
        "storage_key": "property/6737460151191297/019f14e7-ed33-714a-8fa5-7b3b6258559b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jacksonvillezoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14793728661843698434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville-zoo-and-botanical-gardens",
      "poi_latitude": "30.4040262",
      "poi_longitude": "-81.6436476",
      "poi_miles_from_property": "15.6 mi",
      "poi_walking_minutes": "5 hours 50 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 904-757-4463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UOOwKux5YgRAmO1YNbhTc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_e5a17aed029c5b5c6c9c256d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Daily's Place",
      "poi_type": "Entertainment",
      "poi_address": "1 Daily’s Place, Jacksonville, FL 32202, USA",
      "poi_short_description": "Modern outdoor performing-arts center with 5,500 seats hosting a variety of live concerts & events.",
      "poi_long_description": "Modern outdoor performing-arts center with 5,500 seats hosting a variety of live concerts & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-f8d3-740d-b53c-f0a275aaf97a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-f8d3-740d-b53c-f0a275aaf97a",
        "storage_key": "property/6737460151191297/019f14e7-f8d3-740d-b53c-f0a275aaf97a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://dailysplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4625248249833615800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dailys-place",
      "poi_latitude": "30.3221236",
      "poi_longitude": "-81.63784679999999",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-633-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX4Srei25YgRuHFUEccuMEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "ec_7725ecca39d251a140dc8cc0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Ascension St. Vincent's Southside Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4201 Belfort Rd, Jacksonville, FL 32216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-ef83-75b7-a787-e92adda17f41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-ef83-75b7-a787-e92adda17f41",
        "storage_key": "property/6737460151191297/019f14e7-ef83-75b7-a787-e92adda17f41.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/florida/fljac/jacksonville-ascension-st-vincents-southside?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14571536335466991100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-st-vincents-southside-hospital",
      "poi_latitude": "30.2537768",
      "poi_longitude": "-81.5818216",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-296-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62d8-702d-be44-e8eaf2104dd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62d8-702d-be44-e8eaf2104dd7",
        "storage_key": "property/6737460151191297/019f14e5-62d8-702d-be44-e8eaf2104dd7.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVVXm35YgR_A01Axh_OMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_94bafd52cfa6ffc93acb0e26",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "CareSpot Urgent Care of Jacksonville Southside",
      "poi_type": "Health and Wellness",
      "poi_address": "8705 Perimeter Park Blvd #2, Jacksonville, FL 32216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-f878-703c-adda-1ead431c8403.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-f878-703c-adda-1ead431c8403",
        "storage_key": "property/6737460151191297/019f14e7-f878-703c-adda-1ead431c8403.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "https://www.carespot.com/carespot-urgent-care/southside-jacksonville-fl/?utm_source=google&utm_medium=organic&utm_content=southside-jacksonville&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7895085348300190521&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carespot-urgent-care-of-jacksonville-southside",
      "poi_latitude": "30.256905",
      "poi_longitude": "-81.5556865",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-248-3910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiw1YRn615YgROfPSWEv6kG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_d4f3357ae242d14dfe728e0f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4567 River City Dr, Jacksonville, FL 32246, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-f814-77e2-aecf-6339957d286e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-f814-77e2-aecf-6339957d286e",
        "storage_key": "property/6737460151191297/019f14e7-f814-77e2-aecf-6339957d286e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/jacksonville-fl-pharmacies/4567-river-city-dr-jacksonville-fl-32246/storeid=17090?WT.mc_id=LS_GOOGLE_RX_17090",
      "poi_directions_map_url": "https://maps.google.com/?cid=14496091908381292656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.260905",
      "poi_longitude": "-81.524412",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-596-0021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-997e-7695-80d6-19bcd8f1fe10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-997e-7695-80d6-19bcd8f1fe10",
        "storage_key": "property/6737460151191297/019f14e8-997e-7695-80d6-19bcd8f1fe10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJbj0P1e15YgRcDh7fsl2LMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_b0d8a0c4ed4bcb62dfa96406",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Publix Pharmacy at St. John's Town Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4413 Town Center Pkwy #100, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-02b8-7355-8d3b-64852bb85043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-02b8-7355-8d3b-64852bb85043",
        "storage_key": "property/6737460151191297/019f14e8-02b8-7355-8d3b-64852bb85043.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=2678093263034308210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-st-johns-town-center",
      "poi_latitude": "30.2642229",
      "poi_longitude": "-81.5263916",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-564-3790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-997e-7695-80d6-19bcd8f1fe10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-997e-7695-80d6-19bcd8f1fe10",
        "storage_key": "property/6737460151191297/019f14e8-997e-7695-80d6-19bcd8f1fe10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZsOUUW15YgRctaGMqJ_KiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_e30375af9e5b679bf7ae5c45",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9734 Deer Lake Ct Ste 6-7, Jacksonville, FL 32246, USA",
      "poi_short_description": "Gym specializing in group workouts that combine cardio and strength training to hit the optimal fitness zone.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-0257-72ce-b4c1-8878de8352ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-0257-72ce-b4c1-8878de8352ac",
        "storage_key": "property/6737460151191297/019f14e8-0257-72ce-b4c1-8878de8352ac.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/jacksonville-florida-0836?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=14841905586547511692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "30.2648984",
      "poi_longitude": "-81.55478459999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-559-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ9L9Hm15YgRjNEMxH4K-c0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_6615282e2fd9fea352e72f2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "4828 W Deer Lake Dr Suite 7, Jacksonville, FL 32246, USA",
      "poi_short_description": "Chain fitness studio offering low-impact, high-intensity group classes inspired by ballet, Pilates, and yoga.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-fb9c-7528-8391-7b897310460a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-fb9c-7528-8391-7b897310460a",
        "storage_key": "property/6737460151191297/019f14e7-fb9c-7528-8391-7b897310460a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/jacksonville-tapestry-park-fl",
      "poi_directions_map_url": "https://maps.google.com/?cid=14363205406355121501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "30.2589409",
      "poi_longitude": "-81.5542785",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-564-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXcFUmX615YgRXWXEsTdbVMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_5713c7d50b4c9106efbe2ad5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10915 Baymeadows Rd Ste 126, Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e4-fb6b-7798-8865-f1cbec77914c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-fb6b-7798-8865-f1cbec77914c",
        "storage_key": "property/6737460151191297/019f14e4-fb6b-7798-8865-f1cbec77914c.webp",
        "width": 1022,
        "height": 575
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/fl/point-meadows/",
      "poi_directions_map_url": "https://maps.google.com/?cid=792548891008641014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "30.2171883",
      "poi_longitude": "-81.51814279999999",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-371-4550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ452nuCbL5YgR9iezawSz_wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_dbe6b5d496e76e6bdec1eaa6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "F45 Training Deerwood",
      "poi_type": "Health and Wellness",
      "poi_address": "8738 Baymeadows Rd E Suite 104, Jacksonville, FL 32256, USA",
      "poi_short_description": "F45's classes combine cardio and strength training as well as functional moves.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-fb37-7762-8d77-cf99e382204b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-fb37-7762-8d77-cf99e382204b",
        "storage_key": "property/6737460151191297/019f14e7-fb37-7762-8d77-cf99e382204b.webp",
        "width": 948,
        "height": 533
      },
      "poi_business_url": "https://f45training.com/studio/deerwood/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4641128105069389642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f45-training-deerwood",
      "poi_latitude": "30.2179398",
      "poi_longitude": "-81.5101231",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-479-9997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFXrfPYk15IgRSie--2uZaEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0f23c9b2af0e47bcd5d65a04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "River Point Behavioral Health",
      "poi_type": "Health and Wellness",
      "poi_address": "6300 Beach Blvd, Jacksonville, FL 32216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e7-fee7-70fe-bfb6-98076527636e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-fee7-70fe-bfb6-98076527636e",
        "storage_key": "property/6737460151191297/019f14e7-fee7-70fe-bfb6-98076527636e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.riverpointbehavioral.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15371230092518667947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-point-behavioral-health",
      "poi_latitude": "30.2901069",
      "poi_longitude": "-81.59737609999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-724-9202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwSratq15YgRq7ZeMVSUUdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_08eddc1553832139b948718c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Planet fitness (Commerce Center)",
      "poi_type": "Health and Wellness",
      "poi_address": "651 Commerce Center Dr Unit 300, Jacksonville, FL 32225, USA",
      "poi_short_description": "Spacious fitness center offering free weights, machines and a cardio area, plus tanning, massage and hydro-massage machines.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-0af3-774b-a929-20e3012592da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-0af3-774b-a929-20e3012592da",
        "storage_key": "property/6737460151191297/019f14e5-0af3-774b-a929-20e3012592da.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/jacksonville-southside-commons-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3548787503077201584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness-commerce-center",
      "poi_latitude": "30.3344825",
      "poi_longitude": "-81.5499892",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-667-3470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4sFDDW15YgRsBZDiG7TPzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_9e55310816bdf9d721e0cbfc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Touchton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8551 Touchton Rd, Jacksonville, FL 32246, USA",
      "poi_short_description": "Modern play area, plus a pond, exercise equipment and picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-0f99-7056-97ff-cae8555d8321.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-0f99-7056-97ff-cae8555d8321",
        "storage_key": "property/6737460151191297/019f14e8-0f99-7056-97ff-cae8555d8321.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jacksonville.gov/departments/parks-and-recreation/recreation-and-community-programming/parks/touchton-road-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15168449709089788301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "touchton-park",
      "poi_latitude": "30.2697071",
      "poi_longitude": "-81.5689036",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-61fa-76fb-9c73-33c538f2712c",
        "storage_key": "property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YXDMnW15YgRjZGs_6QogdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_bbca1eefa0e7dcb4972fcb19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "The Beach and Peach Urban Bike Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10013 Anders Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "Small, low-key swath of green space with unpaved biking & hiking trails & a fishing pond.",
      "poi_long_description": "Small, low-key swath of green space with unpaved biking & hiking trails & a fishing pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-0ff2-760f-919f-62212cd39961.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-0ff2-760f-919f-62212cd39961",
        "storage_key": "property/6737460151191297/019f14e8-0ff2-760f-919f-62212cd39961.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/beach-and-peach-urban-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18086790759414514098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-beach-and-peach-urban-bike-park",
      "poi_latitude": "30.278133",
      "poi_longitude": "-81.552433",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-233-7450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-61fa-76fb-9c73-33c538f2712c",
        "storage_key": "property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoQcLlg615YgRskG4JV4wAfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3712a00fd64aa292bc091802",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Lovelace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6401 Barnes Rd S, Jacksonville, FL 32216, USA",
      "poi_short_description": "Secluded park with trails, playgrounds, picnic tables, slides, gazebos and BBQ grills.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-1ea6-7660-9873-9044b079e81c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-1ea6-7660-9873-9044b079e81c",
        "storage_key": "property/6737460151191297/019f14e8-1ea6-7660-9873-9044b079e81c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/lovelace-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=933172389785554869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lovelace-park",
      "poi_latitude": "30.2710456",
      "poi_longitude": "-81.59904709999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-255-7907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-61fa-76fb-9c73-33c538f2712c",
        "storage_key": "property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72Bp_eK15YgRtc9eJ1hL8ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ce61bd40e91de8ae4cb63378",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Deerwood Rotary Childrens Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7901 Baymeadows Rd E, Jacksonville, FL 32256, USA",
      "poi_short_description": "Well-kept park featuring 2 playgrounds, a water fountain, swings and slides for kids of all ages.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-156a-734e-9938-98b795edeb40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-156a-734e-9938-98b795edeb40",
        "storage_key": "property/6737460151191297/019f14e8-156a-734e-9938-98b795edeb40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/deerwood-rotary-childrens-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9959795523271334661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deerwood-rotary-childrens-park",
      "poi_latitude": "30.2288538",
      "poi_longitude": "-81.5090835",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-255-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-61fa-76fb-9c73-33c538f2712c",
        "storage_key": "property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dImGjY15IgRBRsdWEJNOIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_47fa1e73dd7b8a350273163b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Tree Hill Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7152 Lone Star Rd, Jacksonville, FL 32211, USA",
      "poi_short_description": "Trails, gardens, wildlife & a natural history museum for children on a large nature reserve.",
      "poi_long_description": "Trails, gardens, wildlife & a natural history museum for children on a large nature reserve.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-1767-73ab-b8dc-b934a657b5cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-1767-73ab-b8dc-b934a657b5cf",
        "storage_key": "property/6737460151191297/019f14e8-1767-73ab-b8dc-b934a657b5cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.treehill.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12888109492179589982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tree-hill-nature-center",
      "poi_latitude": "30.3334246",
      "poi_longitude": "-81.58278620000002",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-724-4646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-61fa-76fb-9c73-33c538f2712c",
        "storage_key": "property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN89aORO05YgRXlu0i0zD27I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_57ddc2b65e61f04a8cc15967",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Castaway Island Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2885 San Pablo Rd S, Jacksonville, FL 32225, USA",
      "poi_short_description": "Raised trails run through this undeveloped wetland preserve with scenic overlooks along the way.",
      "poi_long_description": "Raised trails run through this undeveloped wetland preserve with scenic overlooks along the way.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-10c1-736d-9269-bdc46054ca2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-10c1-736d-9269-bdc46054ca2c",
        "storage_key": "property/6737460151191297/019f14e8-10c1-736d-9269-bdc46054ca2c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.timucuanparks.org/castaway-island-preserve/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14452786049221425949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "castaway-island-preserve",
      "poi_latitude": "30.2961292",
      "poi_longitude": "-81.4376879",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 904-630-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-61fa-76fb-9c73-33c538f2712c",
        "storage_key": "property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrzSJe9NL5IgRHXuQblacksg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2507d87e8e859b2c8efcfee5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Abess Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12743 Abess Blvd, Jacksonville, FL 32225, USA",
      "poi_short_description": "Clean playground with slides, swings and tire swing, along with dog areas, baseball fields, soccer and basketball courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-0e88-71bb-bef7-a279926da376.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-0e88-71bb-bef7-a279926da376",
        "storage_key": "property/6737460151191297/019f14e8-0e88-71bb-bef7-a279926da376.webp",
        "width": 1278,
        "height": 1280
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/leonard-abess-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14755469701282162384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abess-park",
      "poi_latitude": "30.3224355",
      "poi_longitude": "-81.47456849999999",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 904-255-7907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-61fa-76fb-9c73-33c538f2712c",
        "storage_key": "property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4xLYqnVL5IgR0Gb29oP1xcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9b57e4ca2b965b7ddd75d98d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Baldwin Rail Trail - Halsema Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1383 Halsema Rd N, Jacksonville, FL 32220, USA",
      "poi_short_description": "Multi-use paved route for walking, biking and running.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-214b-737c-bc9e-47bac3c68e6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-214b-737c-bc9e-47bac3c68e6a",
        "storage_key": "property/6737460151191297/019f14e8-214b-737c-bc9e-47bac3c68e6a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/jacksonville-baldwin-rail-trail.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=2167268595778487742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baldwin-rail-trail---halsema-trailhead",
      "poi_latitude": "30.3375903",
      "poi_longitude": "-81.8700753",
      "poi_miles_from_property": "22.6 mi",
      "poi_walking_minutes": "8 hours 21 mins",
      "poi_biking_minutes": "2 hours 5 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-61fa-76fb-9c73-33c538f2712c",
        "storage_key": "property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvY2UXYmV5YgRvoU8IE6vEx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c10ecf05414db06dcbbdbcec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Palmetto Leaves Regional Park - Parking",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5760 Greenland Rd, Jacksonville, FL 32258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-1ee9-766f-ac8c-c15865fcb4d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-1ee9-766f-ac8c-c15865fcb4d6",
        "storage_key": "property/6737460151191297/019f14e8-1ee9-766f-ac8c-c15865fcb4d6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/palmetto-leaves-regional-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9106307928106386511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palmetto-leaves-regional-park---parking",
      "poi_latitude": "30.1596543",
      "poi_longitude": "-81.5545638",
      "poi_miles_from_property": "13.6 mi",
      "poi_walking_minutes": "4 hours 59 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-61fa-76fb-9c73-33c538f2712c",
        "storage_key": "property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP8e7ZoHM5YgRT8QaNtAaYH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_de59c99b704b30e4b8960d27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Brackridge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8583 Newton Rd, Jacksonville, FL 32216, USA",
      "poi_short_description": "Shaded playground with slides and picnic tables plus a soccer field.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-2f2d-77c9-95f8-93f6a54f5a24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-2f2d-77c9-95f8-93f6a54f5a24",
        "storage_key": "property/6737460151191297/019f14e8-2f2d-77c9-95f8-93f6a54f5a24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/brackridge-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9949422109856206124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brackridge-park",
      "poi_latitude": "30.2735955",
      "poi_longitude": "-81.5620915",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-630-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-61fa-76fb-9c73-33c538f2712c",
        "storage_key": "property/6737460151191297/019f14e5-61fa-76fb-9c73-33c538f2712c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0QcNbp615YgRLI1l0rFyE4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_408cd89fdd7d7f04b67e6e35",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Touchton Rd. & Southside Blvd.",
      "poi_type": "Transportation & Transit",
      "poi_address": "Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-23d6-765c-b757-287a701790a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-23d6-765c-b757-287a701790a4",
        "storage_key": "property/6737460151191297/019f14e8-23d6-765c-b757-287a701790a4.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8530850915083170535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "touchton-rd--southside-blvd",
      "poi_latitude": "30.269051",
      "poi_longitude": "-81.555877",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj6bwGXe15YgR5zJZebWrY3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_b3df8b4d926baf78d59246a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Touchton Rd. & Deer Lake Ct.",
      "poi_type": "Transportation & Transit",
      "poi_address": "Jacksonville, FL 32216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13600300925045454097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "touchton-rd--deer-lake-ct",
      "poi_latitude": "30.268182",
      "poi_longitude": "-81.55476999999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyv0R3e15YgRETXAQ6L5vbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_41a165f748a3f311eaa35b5d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Deerwood Park Blvd. & Southside Blvd.",
      "poi_type": "Transportation & Transit",
      "poi_address": "Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3343539349304857313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deerwood-park-blvd--southside-blvd",
      "poi_latitude": "30.240184",
      "poi_longitude": "-81.55044199999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_S_To7K5YgR4VLbx1KjZi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_a3e56aa4b76cf5f2f8b32aec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Gate Pkwy & Deerwood Campus Pkwy",
      "poi_type": "Transportation & Transit",
      "poi_address": "Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9370999272582054485&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gate-pkwy--deerwood-campus-pkwy",
      "poi_latitude": "30.258096",
      "poi_longitude": "-81.544893",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YottmO15YgRVYKyUDB6DII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_5cb4a6bf535204c05b5dcdd3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Avenues Walk Park-n-Ride Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "10508 Avenues Walk Blvd, Jacksonville, FL 32258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-36f7-70b8-9c0b-e6cf458a737a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-36f7-70b8-9c0b-e6cf458a737a",
        "storage_key": "property/6737460151191297/019f14e8-36f7-70b8-9c0b-e6cf458a737a.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.jtafla.com/ride-jta/how-to-ride/park-n-ride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1058484284830957639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avenues-walk-park-n-ride-center",
      "poi_latitude": "30.1764331",
      "poi_longitude": "-81.5530462",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 904-630-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUBbmzfL5YgRR8CuVdl9sA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_729ea0605a75f22fddef0ebf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Philips & JTB Park-n-Ride (JTA)",
      "poi_type": "Transportation & Transit",
      "poi_address": "7000 Philips Hwy, Jacksonville, FL 32216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-7451-7758-a177-ec0d0d1c7cad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-7451-7758-a177-ec0d0d1c7cad",
        "storage_key": "property/6737460151191297/019f14e8-7451-7758-a177-ec0d0d1c7cad.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.jtafla.com/ride-jta/how-to-ride/park-n-ride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9702663925565300537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philips--jtb-park-n-ride-jta",
      "poi_latitude": "30.244721",
      "poi_longitude": "-81.60187049999999",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-630-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-9a31-727d-95dc-dfbe5a458413.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-9a31-727d-95dc-dfbe5a458413",
        "storage_key": "property/6737460151191297/019f14e8-9a31-727d-95dc-dfbe5a458413.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJXyGaFR3K5YgROR9R8m7JpoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c7f1a829efe8b4c99877be5e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Jacksonville International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Yankee Clipper Dr, Jacksonville, FL 32218, USA",
      "poi_short_description": "This airport with on-site lodging also features 2 art galleries with rotating exhibitions.",
      "poi_long_description": "This airport with on-site lodging also features 2 art galleries with rotating exhibitions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-3c85-77ef-add6-f03ca711c7d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-3c85-77ef-add6-f03ca711c7d4",
        "storage_key": "property/6737460151191297/019f14e8-3c85-77ef-add6-f03ca711c7d4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.flyjacksonville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1871272610310749030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville-international-airport",
      "poi_latitude": "30.4943308",
      "poi_longitude": "-81.68714969999999",
      "poi_miles_from_property": "22.8 mi",
      "poi_walking_minutes": "8 hours 29 mins",
      "poi_biking_minutes": "2 hours 17 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 904-741-4902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62d0-716d-999d-5b86cc93b960.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62d0-716d-999d-5b86cc93b960",
        "storage_key": "property/6737460151191297/019f14e5-62d0-716d-999d-5b86cc93b960.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0IKb3-v5YgRZnt9T4YY-Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_aac5cb570e4a9ac944939f65",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Florida Blue",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4800 Deerwood Campus Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Insurance carrier with a sprawling campus offering health-related classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-3778-721d-9778-f5163eafb2c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-3778-721d-9778-f5163eafb2c1",
        "storage_key": "property/6737460151191297/019f14e8-3778-721d-9778-f5163eafb2c1.webp",
        "width": 1024,
        "height": 649
      },
      "poi_business_url": "http://www.floridablue.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17422135376572133881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-blue",
      "poi_latitude": "30.2546822",
      "poi_longitude": "-81.5460274",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-352-2583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXW1whZ3K5YgR-TFZjdHbx_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    },
    {
      "id": "ec_24e26a78719ba42732f17d0f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "University of North Florida (UNF)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 UNF Dr., Jacksonville, FL 32224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e4-e953-7421-8020-128a645d1e58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-e953-7421-8020-128a645d1e58",
        "storage_key": "property/6737460151191297/019f14e4-e953-7421-8020-128a645d1e58.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.unf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18226157899370904914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-florida-unf",
      "poi_latitude": "30.2661204",
      "poi_longitude": "-81.50723140000001",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-620-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62b5-735f-81b9-09e25764d63a",
        "storage_key": "property/6737460151191297/019f14e5-62b5-735f-81b9-09e25764d63a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU2DTHbRK5IgRUr0uDAtS8Pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_0c61848ffb6284e5fdaf01c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Eddison at Deerwood Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4435 Touchton Rd, Jacksonville, FL 32246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-4519-722a-a9a2-33cdd6992217.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-4519-722a-a9a2-33cdd6992217",
        "storage_key": "property/6737460151191297/019f14e8-4519-722a-a9a2-33cdd6992217.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.eddisonatdeerwoodpark.com/?utm_medium=organic&utm_source=google&utm_campaign=gmb-website-button",
      "poi_directions_map_url": "https://maps.google.com/?cid=8882121559776630235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eddison-at-deerwood-park",
      "poi_latitude": "30.2662488",
      "poi_longitude": "-81.5497848",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-867-8534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVX2-W-15YgR2xVTxn-iQ3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "ec_229d8f1b352c0329ade6a47d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "HQ Deerwood Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10151 Deerwood Park Blvd 200, Suite 250, Jacksonville, FL 32256, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-4a13-73af-94e8-f07653e69117.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-4a13-73af-94e8-f07653e69117",
        "storage_key": "property/6737460151191297/019f14e8-4a13-73af-94e8-f07653e69117.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hq.com/en/united-states/florida/jacksonville?utm_source=google_uberall&utm_medium=places&utm_campaign=uberall&utm_content=uberall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6261729062532036861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hq-deerwood-park",
      "poi_latitude": "30.2422445",
      "poi_longitude": "-81.54979870000001",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-642-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-XHPko_K5YgR_Tj2A2gh5lY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "real_estate_agency"
    },
    {
      "id": "ec_74c7ad22aa6dec463ca1ecef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "The Winn-Dixie Company Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5050 Edgewood Ct, Jacksonville, FL 32254, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-5718-72dc-9d0d-c0da4a2994d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-5718-72dc-9d0d-c0da4a2994d3",
        "storage_key": "property/6737460151191297/019f14e8-5718-72dc-9d0d-c0da4a2994d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.winndixie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11813128737945114461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-winn-dixie-company-headquarters",
      "poi_latitude": "30.3235416",
      "poi_longitude": "-81.7334585",
      "poi_miles_from_property": "13.8 mi",
      "poi_walking_minutes": "5 hours 8 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 904-783-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4VXt7ae55YgRXVctn_-p8KM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_f6defa09079f25ea19e15f5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Ascension St. Vincent's Riverside",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Shircliff Way, Jacksonville, FL 32204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-444a-7418-890d-bba611f2d3ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-444a-7418-890d-bba611f2d3ed",
        "storage_key": "property/6737460151191297/019f14e8-444a-7418-890d-bba611f2d3ed.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/florida/fljac/jacksonville-ascension-st-vincents-riverside?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12470408444083351860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-st-vincents-riverside",
      "poi_latitude": "30.3076342",
      "poi_longitude": "-81.6889696",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 904-308-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62d8-702d-be44-e8eaf2104dd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62d8-702d-be44-e8eaf2104dd7",
        "storage_key": "property/6737460151191297/019f14e5-62d8-702d-be44-e8eaf2104dd7.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ63i_YIC35YgRNLGeqWjKD60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_78c9b1baa6a03f27a24d601f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "Mayo Clinic",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4500 San Pablo Rd S, Jacksonville, FL 32224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-41f4-70ae-901c-2eb5810133ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-41f4-70ae-901c-2eb5810133ce",
        "storage_key": "property/6737460151191297/019f14e8-41f4-70ae-901c-2eb5810133ce.webp",
        "width": 929,
        "height": 523
      },
      "poi_business_url": "http://www.mayoclinic.org/patient-visitor-guide/florida/campus-buildings-maps/mayo-building-hospital?mc_id=us&utm_source=yext&utm_medium=l&utm_content=feature&utm_campaign=mayoclinic&geo=national&placementsite=enterprise&invsrc=other&cauid=102372&y_source=1_MzkxODQ2OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2898705910926404099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayo-clinic",
      "poi_latitude": "30.2640897",
      "poi_longitude": "-81.4409507",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 904-953-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62d8-702d-be44-e8eaf2104dd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62d8-702d-be44-e8eaf2104dd7",
        "storage_key": "property/6737460151191297/019f14e5-62d8-702d-be44-e8eaf2104dd7.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJk5xKnQ3K5YgRA-oXAatFOig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_ad60c4e567a29dd4536e6f90",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "UF Health Jacksonville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "655 8th St W, Jacksonville, FL 32209, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-495b-7618-8457-41ba1119dea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-495b-7618-8457-41ba1119dea4",
        "storage_key": "property/6737460151191297/019f14e8-495b-7618-8457-41ba1119dea4.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://ufhealthjax.org/locations/uf-health-jacksonville?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=18323229800635225191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uf-health-jacksonville",
      "poi_latitude": "30.3482365",
      "poi_longitude": "-81.66335629999999",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 904-244-0411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-62d8-702d-be44-e8eaf2104dd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-62d8-702d-be44-e8eaf2104dd7",
        "storage_key": "property/6737460151191297/019f14e5-62d8-702d-be44-e8eaf2104dd7.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3HhAzS35YgRZ9S2TGwwSf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_c0840a13f3109f84c6e389bb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "FIS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "347 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-4da5-73ad-8c80-52ef9ab085a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-4da5-73ad-8c80-52ef9ab085a7",
        "storage_key": "property/6737460151191297/019f14e8-4da5-73ad-8c80-52ef9ab085a7.webp",
        "width": 884,
        "height": 584
      },
      "poi_business_url": "https://www.fisglobal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5382664508797814060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fis",
      "poi_latitude": "30.3210514",
      "poi_longitude": "-81.6730915",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 904-438-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-6014-765c-806b-a29f50978701",
        "storage_key": "property/6737460151191297/019f14e5-6014-765c-806b-a29f50978701.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwoIH3K35YgRLAX_J9oQs0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_3bd24bac33490f616e877b22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "generator",
      "poi_name": "NAS Jax",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6801 Roosevelt Blvd, Jacksonville, FL 32212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-5462-7066-a59d-97b9917cb708.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-5462-7066-a59d-97b9917cb708",
        "storage_key": "property/6737460151191297/019f14e8-5462-7066-a59d-97b9917cb708.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cnrse.cnic.navy.mil/Installations/NAS-Jacksonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9352013036945703449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nas-jax",
      "poi_latitude": "30.2257225",
      "poi_longitude": "-81.7001854",
      "poi_miles_from_property": "17.9 mi",
      "poi_walking_minutes": "6 hours 37 mins",
      "poi_biking_minutes": "1 hour 41 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 904-542-2338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14e8-99d7-7578-bd5e-dd302c1ed4ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-99d7-7578-bd5e-dd302c1ed4ae",
        "storage_key": "property/6737460151191297/019f14e8-99d7-7578-bd5e-dd302c1ed4ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVuBltHH5YgRGYL42U4GyYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "custom_fbc26d92-81e5-4ced-9809-fddae0c7e7aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_822c54f5-653b-4512-bc2d-610d15a737a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_81756ce1-592b-4b62-990d-cfb4d88bba89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_515cfa27-4fda-4680-96c9-9ddea67ea0d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e00346fe-209c-4783-b6a1-4c7bb92103db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_364d9790-4859-48c7-96a5-a9837318b961",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_bd4aba4b4d08a3a0a175df21",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "rating": "5",
      "name": "false",
      "text": "I had the pleasure to live in the Wimberly at Deerwood for 3 years, and it was an absolute pleasure. I have lived in several apartment complexes over that past 10 years, and this was by far the best experience I have had. The office staff (especially Rob and Amy) were great to work with, and even just to pop in and chat with. The apartment complex was quiet and very well maintained. Over the past year a new property management company has taken over and has put a lot of money into a make over of the complex including repairing any wood or stone that was bad, new paint on the exteriors, new granite counter tops and stainless steel sinks. The maintenance staff were all friendly and no request that I put in over the 3 years ever took more than a day to take care of. The location was perfect, with many restaurants (including the town center) within 5 minutes. I would recommend this complex to anyone with no hesitation.",
      "date": "false",
      "title": "Absolute Best Value in the Area"
    },
    {
      "id": "ec_7b975fe1ecd0e09b5b4ad7c2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "rating": "5",
      "name": "false",
      "text": "My apartment community is great the staff here is super, and the complex has the best amenities for everybody. It is in a great location very close to everything.",
      "date": "false",
      "title": "My apartment community is great"
    },
    {
      "id": "ec_95f4b448897a5d3b40326277",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "rating": "4",
      "name": "false",
      "text": "Wimberly at Deerwood is located in a great area of Jacksonville! It is just minutes away from Tinseltown and Town Center. We have anything from fast food  to a Brazilian Steak house. Also you are minutes away from great shopping as well!! The staff here are exceptional. They know my family by name!  The apartments have multiple fenced in dog parks and plenty of grassy areas for our furry friends. Also the Wimberly has a rather large pool, that includes both an outdoor grill area and multiple lounge chairs. They also have and indoor half court basketball court, a good sized gym and a theater area! Wimberly at Deerwood has the best animates we have seen so far!!",
      "date": "false",
      "title": "Wimberly at Deerwood"
    },
    {
      "id": "ec_a2e667e40d9aec1ddad24356",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "rating": "4",
      "name": "false",
      "text": "I just moved to Jacksonville for a new job. My company put me at The Wimberly at Deerwood. I was pleasantly surprised and found that it was a very nice complex, nice amenities, and friendly staff.",
      "date": "false",
      "title": "New to Jacksonville"
    },
    {
      "id": "ec_1ef495d6112a6c873f4efe6c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "rating": "5",
      "name": "false",
      "text": "Been living at Wimberly since end of Sept 2018 and absolutely love it! The maintenance team is always on point.  They attend to our requests same day and you can tell they actually get along with one another!\nLeasing office always has resident events and the team is just so friendly! Matt, Brie and Shayna are always willing to help and are super friendly.  Thank you guys for making this a great place for my family and I.  \nOnly thing I would change would be the garbage dump in the front.  Its always full, perhaps you can have the container emptied more often.",
      "date": "false",
      "title": "Tenant"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_61650cbc-8a5b-4121-a16b-f54cf83aee64",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019d02f5-8ddd-7209-a75e-8e98b4a5e44a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area with dining table and bar stools.",
        "public_id": "019d02f5-8ddd-7209-a75e-8e98b4a5e44a",
        "storage_key": "property/6737460151191297/019d02f5-8ddd-7209-a75e-8e98b4a5e44a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 840SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Zfo4FidjuW5"
    },
    {
      "id": "custom_9dcb374b-1269-40ce-8b4b-8667dc146480",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019d02f5-8b96-70d2-a8c2-c67f7e67baac.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior of The Drake at Deerwood apartment community's lobby with a modern fireplace, curved sofa, and reception desk.",
        "public_id": "019d02f5-8b96-70d2-a8c2-c67f7e67baac",
        "storage_key": "property/6737460151191297/019d02f5-8b96-70d2-a8c2-c67f7e67baac.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubroom",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AFciE1xXw9M"
    },
    {
      "id": "custom_7b3f18d4-419b-495e-970e-162133ad79ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019d02f5-8c8f-7360-81a2-d5baf19ba84c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior of a well-equipped apartment gym with weight machines and treadmills.",
        "public_id": "019d02f5-8c8f-7360-81a2-d5baf19ba84c",
        "storage_key": "property/6737460151191297/019d02f5-8c8f-7360-81a2-d5baf19ba84c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=RNQeuAY1Bbw"
    },
    {
      "id": "custom_416751a6-bb87-402a-adaa-39502cd417ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f14c2-8f1d-73bc-8fcd-cf5f17ac08ba.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-8f1d-73bc-8fcd-cf5f17ac08ba",
        "storage_key": "property/6737460151191297/019f14c2-8f1d-73bc-8fcd-cf5f17ac08ba.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Drake at Deerwood | Property Video",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/IVuxcFomUZE?rel=0"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-807d-70e4-8387-d797a3e0761c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-drake-at-deerwood",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297"
    },
    {
      "lead_collector_id": "0198aa46-80e1-77d5-9907-dcae2692b4ae",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-drake-at-deerwood",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297"
    },
    {
      "lead_collector_id": "0198aa46-8144-7478-86f8-15dd34167740",
      "lead_source": "LANDING_PAGE",
      "name": "the-drake-at-deerwood",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-jacksonville-fl",
      "search_query": "One Bedroom Apartments For Rent In Jacksonville FL",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent In Jacksonville FL",
      "h2_subtitle": "The Drake at Deerwood offers spacious one-bedroom apartments designed for your comfort. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where our one-bedroom apartments for rent in Jacksonville, FL, provide the perfect blend of comfort and convenience. Each apartment features modern amenities such as air conditioning, granite countertops, and stainless steel appliances, ensuring a luxurious living experience. \n\nLocated at 9727 Touchton Rd, our community offers easy access to everything Jacksonville has to offer. With options like hardwood floors, double vanities, and a cozy fireplace, you'll find the perfect space to call home. Enjoy the convenience of nearby shopping, dining, and entertainment, all while living in a community that prioritizes your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | One Bedroom Apartments For Rent In Jacksonville FL",
      "seo_description": "Explore The Drake at Deerwood's one-bedroom apartments for rent in Jacksonville, FL. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-jacksonville-fl",
      "search_query": "Two Bedrooms Apartments For Rent In Jacksonville FL",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedrooms Apartments For Rent In Jacksonville FL",
      "h2_subtitle": "The Drake at Deerwood offers spacious two-bedroom apartments for your comfort. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Discover the perfect two-bedroom apartments for rent in Jacksonville, FL, at The Drake at Deerwood. Our apartments are designed to provide a comfortable and convenient living experience, featuring amenities like air conditioning, granite countertops, and stainless steel appliances. \n\nLocated at 9727 Touchton Rd, our community ensures easy access to Jacksonville's best offerings. With features such as hardwood floors, double vanities, and a cozy fireplace, you'll find a welcoming space to call home. Enjoy the convenience of nearby shopping, dining, and entertainment, all while living in a community that caters to your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Two Bedrooms Apartments For Rent In Jacksonville FL",
      "seo_description": "Find two-bedroom apartments for rent in Jacksonville, FL, at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "find-three-bedrooms-apartments-for-rent-jacksonville-fl",
      "search_query": "Three Bedrooms Apartments For Rent In Jacksonville FL",
      "category": "Floorplan",
      "h1_title": "Find Three Bedrooms Apartments For Rent In Jacksonville FL",
      "h2_subtitle": "The Drake at Deerwood offers spacious three-bedroom apartments for your comfort. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Experience the ideal living space with our three-bedroom apartments for rent in Jacksonville, FL, at The Drake at Deerwood. Designed for quality and comfort, these apartments feature modern amenities such as air conditioning, granite countertops, and stainless steel appliances to enhance your lifestyle.\n\nSituated at 9727 Touchton Rd, our community provides easy access to Jacksonville's vibrant offerings. With features like hardwood floors, double vanities, and a cozy fireplace, you'll find a welcoming and spacious home. Enjoy the convenience of nearby shopping, dining, and entertainment, all while living in a community that supports your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Three Bedrooms Apartments For Rent In Jacksonville FL",
      "seo_description": "Discover three-bedroom apartments for rent in Jacksonville, FL, at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Pool",
      "h2_subtitle": "The Drake at Deerwood offers luxurious apartments with a pool and more. Enjoy a variety of amenities and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where you can find apartments for rent near me with pool access in Jacksonville, FL. Our community features a stunning pool, perfect for relaxation and leisure, along with a fitness center, clubhouse, and more to enhance your living experience.\n\nLocated at 9727 Touchton Rd, our apartments offer a variety of floor plans, including 1, 2, and 3 bedrooms, designed for your comfort and convenience. Enjoy the benefits of a vibrant community with amenities like a sundeck, grill, and picnic area, all while being centrally located for easy access to shopping, dining, and entertainment. Experience the perfect blend of luxury and convenience at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent Near Me with Pool",
      "seo_description": "Find apartments for rent near me with pool access at The Drake at Deerwood in Jacksonville, FL. Enjoy luxurious amenities and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "The Drake at Deerwood offers modern apartments with a fitness center. Enjoy a variety of amenities and a prime location in Jacksonville, FL.",
      "page_copy": "Discover your new home at The Drake at Deerwood, where you can find apartments for rent near me with a fitness center in Jacksonville, FL. Our community features a state-of-the-art fitness center, perfect for maintaining an active lifestyle, along with a pool, clubhouse, and more to enhance your living experience.\n\nLocated at 9727 Touchton Rd, our apartments offer a range of floor plans, including 1, 2, and 3 bedrooms, designed for your comfort and convenience. Enjoy the benefits of a vibrant community with amenities like a gameroom, sundeck, and picnic area, all while being centrally located for easy access to shopping, dining, and entertainment. Experience the perfect blend of luxury and convenience at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with a fitness center at The Drake at Deerwood in Jacksonville, FL. Enjoy luxurious amenities and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-jacksonville-near-ascension",
      "search_query": "Apartments For Rent In Jacksonville FL Near Ascension St. Vincent's Riverside",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Ascension St. Vincent's Riverside",
      "h2_subtitle": "The Drake at Deerwood offers convenient living near Ascension St. Vincent's Riverside. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where you can find apartments for rent in Jacksonville, FL, near Ascension St. Vincent's Riverside. Our community offers a perfect blend of comfort and convenience, with easy access to the hospital's specialty and emergency care services.\n\nLocated at 9727 Touchton Rd, our apartments provide a range of floor plans, including 1, 2, and 3 bedrooms, designed for your lifestyle needs. Enjoy community amenities like a fitness center, pool, and clubhouse, along with apartment features such as granite countertops and stainless steel appliances. Experience the ideal living environment with proximity to healthcare and a vibrant community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Ascension St. Vincent's Riverside",
      "seo_description": "Discover apartments for rent in Jacksonville, FL, near Ascension St. Vincent's Riverside at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-jacksonville-fl-near-ct-scan",
      "search_query": "Apartments For Rent In Jacksonville FL Near CT Scan - Baptist Jacksonville",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Jacksonville FL Near CT Scan - Baptist Jacksonville",
      "h2_subtitle": "The Drake at Deerwood offers convenient living near CT Scan - Baptist Jacksonville. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where you can find apartments for rent in Jacksonville, FL, near CT Scan - Baptist Jacksonville. Our community provides a comfortable and convenient living experience, with easy access to the hospital's advanced imaging services.\n\nLocated at 9727 Touchton Rd, our apartments offer a selection of floor plans, including 1, 2, and 3 bedrooms, designed to meet your lifestyle needs. Enjoy community amenities like a fitness center, pool, and business center, along with apartment features such as granite countertops and stainless steel appliances. Experience the ideal living environment with proximity to healthcare and a vibrant community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near CT Scan - Baptist Jacksonville",
      "seo_description": "Discover apartments for rent in Jacksonville, FL, near CT Scan - Baptist Jacksonville at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-jacksonville-near-melissa-deese",
      "search_query": "Apartments For Rent In Jacksonville FL Near Melissa Deese, PT",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Melissa Deese, PT",
      "h2_subtitle": "The Drake at Deerwood offers convenient living near Melissa Deese, PT at Mayo Clinic. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where you can find apartments for rent in Jacksonville, FL, near Melissa Deese, PT at Mayo Clinic. Our community provides a comfortable and convenient living experience, with easy access to Mayo Clinic's expert care and healing environment.\n\nLocated at 9727 Touchton Rd, our apartments offer a selection of floor plans, including 1, 2, and 3 bedrooms, designed to meet your lifestyle needs. Enjoy community amenities like a fitness center, pool, and business center, along with apartment features such as granite countertops and stainless steel appliances. Experience the ideal living environment with proximity to healthcare and a vibrant community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Melissa Deese, PT",
      "seo_description": "Discover apartments for rent in Jacksonville, FL, near Melissa Deese, PT at Mayo Clinic at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-in-jacksonville-fl",
      "search_query": "Apartments For Rent In Jacksonville FL Near Vanessa Hearnshaw, PT",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Jacksonville FL Near Vanessa Hearnshaw, PT",
      "h2_subtitle": "The Drake at Deerwood offers convenient living near Vanessa Hearnshaw, PT. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where you can find apartments for rent in Jacksonville, FL, near Vanessa Hearnshaw, PT. Our community provides a comfortable and convenient living experience, with easy access to local healthcare services.\n\nLocated at 9727 Touchton Rd, our apartments offer a selection of floor plans, including 1, 2, and 3 bedrooms, designed to meet your lifestyle needs. Enjoy community amenities like a fitness center, pool, and business center, along with apartment features such as granite countertops and stainless steel appliances. Experience the ideal living environment with proximity to healthcare and a vibrant community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Vanessa Hearnshaw, PT",
      "seo_description": "Discover apartments for rent in Jacksonville, FL, near Vanessa Hearnshaw, PT at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-jacksonville-near-wolfson-childrens-hospital",
      "search_query": "Apartments For Rent In Jacksonville FL Near Wolfson Children's Hospital: Irazuzta Jose E MD",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Wolfson Children's Hospital: Irazuzta Jose E MD",
      "h2_subtitle": "The Drake at Deerwood offers convenient living near Wolfson Children's Hospital. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where you can find apartments for rent in Jacksonville, FL, near Wolfson Children's Hospital: Irazuzta Jose E MD. Our community provides a comfortable and convenient living experience, with easy access to the hospital's specialized pediatric care.\n\nLocated at 9727 Touchton Rd, our apartments offer a selection of floor plans, including 1, 2, and 3 bedrooms, designed to meet your lifestyle needs. Enjoy community amenities like a fitness center, pool, and business center, along with apartment features such as granite countertops and stainless steel appliances. Experience the ideal living environment with proximity to healthcare and a vibrant community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Wolfson Children's Hospital: Irazuzta Jose E MD",
      "seo_description": "Discover apartments for rent in Jacksonville, FL, near Wolfson Children's Hospital: Irazuzta Jose E MD at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-university-florida",
      "search_query": "Apartments For Rent In Jacksonville FL Near University Of Florida Div/rhu",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Jacksonville FL Near University Of Florida Div/rhu",
      "h2_subtitle": "The Drake at Deerwood offers convenient living near University Of Florida Div/rhu. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where you can find apartments for rent in Jacksonville, FL, near University Of Florida Div/rhu. Our community provides a comfortable and convenient living experience, with easy access to the university's educational and research facilities.\n\nLocated at 9727 Touchton Rd, our apartments offer a selection of floor plans, including 1, 2, and 3 bedrooms, designed to meet your lifestyle needs. Enjoy community amenities like a fitness center, pool, and business center, along with apartment features such as granite countertops and stainless steel appliances. Experience the ideal living environment with proximity to education and a vibrant community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near University Of Florida Div/rhu",
      "seo_description": "Discover apartments for rent in Jacksonville, FL, near University Of Florida Div/rhu at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-jacksonville-near-university",
      "search_query": "Apartments For Rent In Jacksonville FL Near Jacksonville University",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Jacksonville University",
      "h2_subtitle": "The Drake at Deerwood offers convenient living near Jacksonville University. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where you can find apartments for rent in Jacksonville, FL, near Jacksonville University. Our community provides a comfortable and convenient living experience, with easy access to the university's academic and social activities.\n\nLocated at 9727 Touchton Rd, our apartments offer a selection of floor plans, including 1, 2, and 3 bedrooms, designed to meet your lifestyle needs. Enjoy community amenities like a fitness center, pool, and business center, along with apartment features such as granite countertops and stainless steel appliances. Experience the ideal living environment with proximity to education and a vibrant community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Jacksonville University",
      "seo_description": "Discover apartments for rent in Jacksonville, FL, near Jacksonville University at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-florida-state-college",
      "search_query": "Apartments For Rent In Jacksonville FL Near Florida State College at Jacksonville: Kent Campus",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Jacksonville FL Near Florida State College at Jacksonville: Kent Campus",
      "h2_subtitle": "The Drake at Deerwood offers convenient living near Florida State College at Jacksonville: Kent Campus. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where you can find apartments for rent in Jacksonville, FL, near Florida State College at Jacksonville: Kent Campus. Our community provides a comfortable and convenient living experience, with easy access to the college's educational resources and activities.\n\nLocated at 9727 Touchton Rd, our apartments offer a selection of floor plans, including 1, 2, and 3 bedrooms, designed to meet your lifestyle needs. Enjoy community amenities like a fitness center, pool, and business center, along with apartment features such as granite countertops and stainless steel appliances. Experience the ideal living environment with proximity to education and a vibrant community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Florida State College at Jacksonville: Kent Campus",
      "seo_description": "Discover apartments for rent in Jacksonville, FL, near Florida State College at Jacksonville: Kent Campus at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-jacksonville-fl-near-edward-waters",
      "search_query": "Apartments For Rent In Jacksonville FL Near Edward Waters University",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Edward Waters University",
      "h2_subtitle": "The Drake at Deerwood offers convenient living near Edward Waters University. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where you can find apartments for rent in Jacksonville, FL, near Edward Waters University. Our community provides a comfortable and convenient living experience, with easy access to the university's academic and social activities.\n\nLocated at 9727 Touchton Rd, our apartments offer a selection of floor plans, including 1, 2, and 3 bedrooms, designed to meet your lifestyle needs. Enjoy community amenities like a fitness center, pool, and business center, along with apartment features such as granite countertops and stainless steel appliances. Experience the ideal living environment with proximity to education and a vibrant community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Edward Waters University",
      "seo_description": "Discover apartments for rent in Jacksonville, FL, near Edward Waters University at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-in-jacksonville-fl-near-chamberlain-university",
      "search_query": "Apartments For Rent In Jacksonville FL Near Chamberlain University - Jacksonville",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Jacksonville FL Near Chamberlain University - Jacksonville",
      "h2_subtitle": "The Drake at Deerwood offers convenient living near Chamberlain University - Jacksonville. Enjoy a variety of features and a prime location in Jacksonville, FL.",
      "page_copy": "Welcome to The Drake at Deerwood, where you can find apartments for rent in Jacksonville, FL, near Chamberlain University - Jacksonville. Our community provides a comfortable and convenient living experience, with easy access to the university's educational resources and activities.\n\nLocated at 9727 Touchton Rd, our apartments offer a selection of floor plans, including 1, 2, and 3 bedrooms, designed to meet your lifestyle needs. Enjoy community amenities like a fitness center, pool, and business center, along with apartment features such as granite countertops and stainless steel appliances. Experience the ideal living environment with proximity to education and a vibrant community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Chamberlain University - Jacksonville",
      "seo_description": "Discover apartments for rent in Jacksonville, FL, near Chamberlain University - Jacksonville at The Drake at Deerwood. Enjoy modern features and a prime location for your ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-jacksonville-fl-near-hogan-spring-glen",
      "search_query": "Apartments For Rent In Jacksonville FL Near Hogan-Spring Glen Elementary School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Hogan-Spring Glen Elementary School",
      "h2_subtitle": "The Drake at Deerwood offers family-friendly living just 5.5 km from Hogan-Spring Glen Elementary School. Enjoy spacious floor plans and a variety of amenities.",
      "page_copy": "Welcome to The Drake at Deerwood, where families can find the perfect apartments for rent in Jacksonville, FL, near Hogan-Spring Glen Elementary School. Located just 5.5 km away, our community offers the ideal setting for families seeking quality education within the Duval County School District.\n\nChoose from our spacious 1, 2, and 3-bedroom floor plans, designed for comfort and convenience. Our community features family-friendly amenities such as a pool, fitness center, and playground, ensuring a vibrant lifestyle for all ages. With granite countertops, stainless steel appliances, and hardwood floors, our apartments provide a modern and welcoming home environment. Experience the perfect blend of proximity to education and a supportive community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Hogan-Spring Glen Elementary School",
      "seo_description": "Discover family-friendly apartments for rent in Jacksonville, FL, near Hogan-Spring Glen Elementary School at The Drake at Deerwood. Enjoy modern features and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-jacksonville-fl-near-duval-school",
      "search_query": "Apartments For Rent In Jacksonville FL Near Duval Charter School at Southside K-8",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Jacksonville FL Near Duval Charter School at Southside K-8",
      "h2_subtitle": "The Drake at Deerwood offers family-friendly living just 5.5 km from Duval Charter School at Southside K-8. Enjoy spacious floor plans and a variety of amenities.",
      "page_copy": "Welcome to The Drake at Deerwood, where families can find the perfect apartments for rent in Jacksonville, FL, near Duval Charter School at Southside K-8. Located just 5.5 km away, our community provides an ideal setting for families seeking quality education in a tuition-free public charter school.\n\nChoose from our spacious 1, 2, and 3-bedroom floor plans, designed for comfort and convenience. Our community features family-friendly amenities such as a pool, fitness center, and playground, ensuring a vibrant lifestyle for all ages. With granite countertops, stainless steel appliances, and hardwood floors, our apartments provide a modern and welcoming home environment. Experience the perfect blend of proximity to education and a supportive community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Duval Charter School at Southside K-8",
      "seo_description": "Discover family-friendly apartments for rent in Jacksonville, FL, near Duval Charter School at Southside K-8 at The Drake at Deerwood. Enjoy modern features and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-jacksonville-fl-near-twin-lakes-academy",
      "search_query": "Apartments For Rent In Jacksonville FL Near Twin Lakes Academy Middle School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Jacksonville FL Near Twin Lakes Academy Middle School",
      "h2_subtitle": "The Drake at Deerwood offers family-friendly living just 9.5 km from Twin Lakes Academy Middle School. Enjoy spacious floor plans and a variety of amenities.",
      "page_copy": "Welcome to The Drake at Deerwood, where families can find the perfect apartments for rent in Jacksonville, FL, near Twin Lakes Academy Middle School. Located just 9.5 km away, our community provides an ideal setting for families seeking quality education within the Duval County School District.\n\nChoose from our spacious 1, 2, and 3-bedroom floor plans, designed for comfort and convenience. Our community features family-friendly amenities such as a pool, fitness center, and playground, ensuring a vibrant lifestyle for all ages. With granite countertops, stainless steel appliances, and hardwood floors, our apartments provide a modern and welcoming home environment. Experience the perfect blend of proximity to education and a supportive community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Twin Lakes Academy Middle School",
      "seo_description": "Discover family-friendly apartments for rent in Jacksonville, FL, near Twin Lakes Academy Middle School at The Drake at Deerwood. Enjoy modern features and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-jacksonville-fl-near-river-city",
      "search_query": "Apartments For Rent In Jacksonville FL Near River City Science Academy Innovation (K - 8)",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Jacksonville FL Near River City Science Academy Innovation (K - 8)",
      "h2_subtitle": "The Drake at Deerwood offers family-friendly living just 9.7 km from River City Science Academy Innovation. Enjoy spacious floor plans and a variety of amenities.",
      "page_copy": "Welcome to The Drake at Deerwood, where families can find the perfect apartments for rent in Jacksonville, FL, near River City Science Academy Innovation (K - 8). Located just 9.7 km away, our community provides an ideal setting for families seeking a STEM-focused education in a tuition-free public charter school.\n\nChoose from our spacious 1, 2, and 3-bedroom floor plans, designed for comfort and convenience. Our community features family-friendly amenities such as a pool, fitness center, and playground, ensuring a vibrant lifestyle for all ages. With granite countertops, stainless steel appliances, and hardwood floors, our apartments provide a modern and welcoming home environment. Experience the perfect blend of proximity to education and a supportive community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near River City Science Academy Innovation (K - 8)",
      "seo_description": "Discover family-friendly apartments for rent in Jacksonville, FL, near River City Science Academy Innovation (K - 8) at The Drake at Deerwood. Enjoy modern features and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6737460151191297",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-jacksonville-near-englewood",
      "search_query": "Apartments For Rent In Jacksonville FL Near Englewood High School",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Jacksonville FL Near Englewood High School",
      "h2_subtitle": "The Drake at Deerwood offers family-friendly living just 8.4 km from Englewood High School. Enjoy spacious floor plans and a variety of amenities.",
      "page_copy": "Welcome to The Drake at Deerwood, where families can find the perfect apartments for rent in Jacksonville, FL, near Englewood High School. Located just 8.4 km away, our community provides an ideal setting for families seeking quality education within the Duval County School District.\n\nChoose from our spacious 1, 2, and 3-bedroom floor plans, designed for comfort and convenience. Our community features family-friendly amenities such as a pool, fitness center, and playground, ensuring a vibrant lifestyle for all ages. With granite countertops, stainless steel appliances, and hardwood floors, our apartments provide a modern and welcoming home environment. Experience the perfect blend of proximity to education and a supportive community at The Drake at Deerwood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool with waterfalls and palm trees at dusk.",
        "public_id": "019f6c12-3bb8-73cc-b937-508e2b0ecfb1",
        "storage_key": "property/6737460151191297/019f6c12-3bb8-73cc-b937-508e2b0ecfb1.webp",
        "width": 500,
        "height": 500
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a luxury apartment building with landscaping",
        "public_id": "019f6c12-41a7-70ef-8372-1078afeb0491",
        "storage_key": "property/6737460151191297/019f6c12-41a7-70ef-8372-1078afeb0491.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Drake at Deerwood | Apartments For Rent In Jacksonville FL Near Englewood High School",
      "seo_description": "Discover family-friendly apartments for rent in Jacksonville, FL, near Englewood High School at The Drake at Deerwood. Enjoy modern features and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3250"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "4837992279"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a52\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a52\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5203549"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NPF8CW3T"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "4"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "16626299920"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "11f1abf28712d220"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/60p7qgz3w7n"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/e00860e2-c5c3-4516-975b-3b01dad38dfc"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "904-746-4265"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlZBRzZVQ01lbTdlbmdhTU5wNHE4dkE9PSIsInZhbHVlIjoiLzZVN0txUnM1Y3pLb01xNFhTcFo5QT09IiwibWFjIjoiZDY3ZmVlZjVkYTkyNGJiMTExOTA4MzUzZWNjNGZhMGVhMWU4ZTZhYmUxMDFjNDdiNzY1NDExYTRiODRmNTJlNiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "3250",
  "custom_repli_id": "4837992279",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a52\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a52\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5203549",
  "custom_google_gtm_id": "GTM-NPF8CW3T",
  "custom_rollout_phase": "4",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "16626299920",
  "custom_knock_community_id": "11f1abf28712d220",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/60p7qgz3w7n",
  "custom_self_guided_tour_url": "https://selftournow.com/property/e00860e2-c5c3-4516-975b-3b01dad38dfc",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "904-746-4265",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlZBRzZVQ01lbTdlbmdhTU5wNHE4dkE9PSIsInZhbHVlIjoiLzZVN0txUnM1Y3pLb01xNFhTcFo5QT09IiwibWFjIjoiZDY3ZmVlZjVkYTkyNGJiMTExOTA4MzUzZWNjNGZhMGVhMWU4ZTZhYmUxMDFjNDdiNzY1NDExYTRiODRmNTJlNiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "08ac44e2-85d6-4333-91eb-9566f334ca2c",
  "custom_audioeye_site_hash": "68dbf2cfad8a898ee11af91edc121e64"
};

export const generatedAt = '2026-11-03T20:26:09.764Z';
